// This client was generated by Platformatic from an OpenAPI specification.

import type { Api } from './api-types'
import type * as Types from './api-types'

// The base URL for the API. This can be overridden by calling `setBaseUrl`.
let baseUrl = ''
// The default headers to send within each request. This can be overridden by calling `setDefaultHeaders`.
let defaultHeaders = {}

function sanitizeUrl(url: string) : string {
  if (url.endsWith('/')) { return url.slice(0, -1) } else { return url }
}
export const setBaseUrl = (newUrl: string) : void => { baseUrl = sanitizeUrl(newUrl) }

export const setDefaultHeaders = (headers: Object): void => { defaultHeaders = headers }

type JSON = Record<string, unknown>
/* @ts-ignore */
function headersToJSON(headers: Headers): JSON {
  const output: JSON = {}
  headers.forEach((value, key) => {
    output[key] = value
  })
  return output
}

const _getV1ShippingRules = async (url: string, request: Types.GetV1ShippingRulesRequest): Promise<Types.GetV1ShippingRulesResponses> => {
  const queryParameters: (keyof Types.GetV1ShippingRulesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/shipping-rules/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ShippingRules: Api['getV1ShippingRules'] = async (request: Types.GetV1ShippingRulesRequest): Promise<Types.GetV1ShippingRulesResponses> => {
  return await _getV1ShippingRules(baseUrl, request)
}
const _postV1ShippingRules = async (url: string, request: Types.PostV1ShippingRulesRequest): Promise<Types.PostV1ShippingRulesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/shipping-rules/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ShippingRules: Api['postV1ShippingRules'] = async (request: Types.PostV1ShippingRulesRequest): Promise<Types.PostV1ShippingRulesResponses> => {
  return await _postV1ShippingRules(baseUrl, request)
}
const _getV1ShippingRulesId = async (url: string, request: Types.GetV1ShippingRulesIdRequest): Promise<Types.GetV1ShippingRulesIdResponses> => {
  const queryParameters: (keyof Types.GetV1ShippingRulesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/shipping-rules/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ShippingRulesId: Api['getV1ShippingRulesId'] = async (request: Types.GetV1ShippingRulesIdRequest): Promise<Types.GetV1ShippingRulesIdResponses> => {
  return await _getV1ShippingRulesId(baseUrl, request)
}
const _putV1ShippingRulesId = async (url: string, request: Types.PutV1ShippingRulesIdRequest): Promise<Types.PutV1ShippingRulesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/shipping-rules/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1ShippingRulesId: Api['putV1ShippingRulesId'] = async (request: Types.PutV1ShippingRulesIdRequest): Promise<Types.PutV1ShippingRulesIdResponses> => {
  return await _putV1ShippingRulesId(baseUrl, request)
}
const _deleteV1ShippingRulesId = async (url: string, request: Types.DeleteV1ShippingRulesIdRequest): Promise<Types.DeleteV1ShippingRulesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/shipping-rules/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1ShippingRulesId: Api['deleteV1ShippingRulesId'] = async (request: Types.DeleteV1ShippingRulesIdRequest): Promise<Types.DeleteV1ShippingRulesIdResponses> => {
  return await _deleteV1ShippingRulesId(baseUrl, request)
}
const _postV1ShippingRulesSaveAsDraft = async (url: string, request: Types.PostV1ShippingRulesSaveAsDraftRequest): Promise<Types.PostV1ShippingRulesSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/shipping-rules/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ShippingRulesSaveAsDraft: Api['postV1ShippingRulesSaveAsDraft'] = async (request: Types.PostV1ShippingRulesSaveAsDraftRequest): Promise<Types.PostV1ShippingRulesSaveAsDraftResponses> => {
  return await _postV1ShippingRulesSaveAsDraft(baseUrl, request)
}
const _getV1ShippingRulesGenerateExcel = async (url: string, request: Types.GetV1ShippingRulesGenerateExcelRequest): Promise<Types.GetV1ShippingRulesGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1ShippingRulesGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/shipping-rules/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ShippingRulesGenerateExcel: Api['getV1ShippingRulesGenerateExcel'] = async (request: Types.GetV1ShippingRulesGenerateExcelRequest): Promise<Types.GetV1ShippingRulesGenerateExcelResponses> => {
  return await _getV1ShippingRulesGenerateExcel(baseUrl, request)
}
const _postV1ShippingRulesImport = async (url: string, request: Types.PostV1ShippingRulesImportRequest): Promise<Types.PostV1ShippingRulesImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/shipping-rules/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ShippingRulesImport: Api['postV1ShippingRulesImport'] = async (request: Types.PostV1ShippingRulesImportRequest): Promise<Types.PostV1ShippingRulesImportResponses> => {
  return await _postV1ShippingRulesImport(baseUrl, request)
}
const _getV1ShippingRulesGeneratePdf = async (url: string, request: Types.GetV1ShippingRulesGeneratePdfRequest): Promise<Types.GetV1ShippingRulesGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1ShippingRulesGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/shipping-rules/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1ShippingRulesGeneratePdf: Api['getV1ShippingRulesGeneratePdf'] = async (request: Types.GetV1ShippingRulesGeneratePdfRequest): Promise<Types.GetV1ShippingRulesGeneratePdfResponses> => {
  return await _getV1ShippingRulesGeneratePdf(baseUrl, request)
}
const _getV1DeliverySettings = async (url: string, request: Types.GetV1DeliverySettingsRequest): Promise<Types.GetV1DeliverySettingsResponses> => {
  const queryParameters: (keyof Types.GetV1DeliverySettingsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-settings/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliverySettings: Api['getV1DeliverySettings'] = async (request: Types.GetV1DeliverySettingsRequest): Promise<Types.GetV1DeliverySettingsResponses> => {
  return await _getV1DeliverySettings(baseUrl, request)
}
const _patchV1DeliverySettingsId = async (url: string, request: Types.PatchV1DeliverySettingsIdRequest): Promise<Types.PatchV1DeliverySettingsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-settings/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1DeliverySettingsId: Api['patchV1DeliverySettingsId'] = async (request: Types.PatchV1DeliverySettingsIdRequest): Promise<Types.PatchV1DeliverySettingsIdResponses> => {
  return await _patchV1DeliverySettingsId(baseUrl, request)
}
const _getV1CustomerSegment = async (url: string, request: Types.GetV1CustomerSegmentRequest): Promise<Types.GetV1CustomerSegmentResponses> => {
  const queryParameters: (keyof Types.GetV1CustomerSegmentRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-segment/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CustomerSegment: Api['getV1CustomerSegment'] = async (request: Types.GetV1CustomerSegmentRequest): Promise<Types.GetV1CustomerSegmentResponses> => {
  return await _getV1CustomerSegment(baseUrl, request)
}
const _postV1CustomerSegment = async (url: string, request: Types.PostV1CustomerSegmentRequest): Promise<Types.PostV1CustomerSegmentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-segment/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CustomerSegment: Api['postV1CustomerSegment'] = async (request: Types.PostV1CustomerSegmentRequest): Promise<Types.PostV1CustomerSegmentResponses> => {
  return await _postV1CustomerSegment(baseUrl, request)
}
const _postV1CustomerSegmentSaveAsDraft = async (url: string, request: Types.PostV1CustomerSegmentSaveAsDraftRequest): Promise<Types.PostV1CustomerSegmentSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-segment/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CustomerSegmentSaveAsDraft: Api['postV1CustomerSegmentSaveAsDraft'] = async (request: Types.PostV1CustomerSegmentSaveAsDraftRequest): Promise<Types.PostV1CustomerSegmentSaveAsDraftResponses> => {
  return await _postV1CustomerSegmentSaveAsDraft(baseUrl, request)
}
const _getV1CustomerSegmentId = async (url: string, request: Types.GetV1CustomerSegmentIdRequest): Promise<Types.GetV1CustomerSegmentIdResponses> => {
  const queryParameters: (keyof Types.GetV1CustomerSegmentIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-segment/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CustomerSegmentId: Api['getV1CustomerSegmentId'] = async (request: Types.GetV1CustomerSegmentIdRequest): Promise<Types.GetV1CustomerSegmentIdResponses> => {
  return await _getV1CustomerSegmentId(baseUrl, request)
}
const _putV1CustomerSegmentId = async (url: string, request: Types.PutV1CustomerSegmentIdRequest): Promise<Types.PutV1CustomerSegmentIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-segment/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CustomerSegmentId: Api['putV1CustomerSegmentId'] = async (request: Types.PutV1CustomerSegmentIdRequest): Promise<Types.PutV1CustomerSegmentIdResponses> => {
  return await _putV1CustomerSegmentId(baseUrl, request)
}
const _deleteV1CustomerSegmentId = async (url: string, request: Types.DeleteV1CustomerSegmentIdRequest): Promise<Types.DeleteV1CustomerSegmentIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-segment/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CustomerSegmentId: Api['deleteV1CustomerSegmentId'] = async (request: Types.DeleteV1CustomerSegmentIdRequest): Promise<Types.DeleteV1CustomerSegmentIdResponses> => {
  return await _deleteV1CustomerSegmentId(baseUrl, request)
}
const _getV1CustomerSegmentGenerateExcel = async (url: string, request: Types.GetV1CustomerSegmentGenerateExcelRequest): Promise<Types.GetV1CustomerSegmentGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CustomerSegmentGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-segment/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CustomerSegmentGenerateExcel: Api['getV1CustomerSegmentGenerateExcel'] = async (request: Types.GetV1CustomerSegmentGenerateExcelRequest): Promise<Types.GetV1CustomerSegmentGenerateExcelResponses> => {
  return await _getV1CustomerSegmentGenerateExcel(baseUrl, request)
}
const _postV1CustomerSegmentImport = async (url: string, request: Types.PostV1CustomerSegmentImportRequest): Promise<Types.PostV1CustomerSegmentImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-segment/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CustomerSegmentImport: Api['postV1CustomerSegmentImport'] = async (request: Types.PostV1CustomerSegmentImportRequest): Promise<Types.PostV1CustomerSegmentImportResponses> => {
  return await _postV1CustomerSegmentImport(baseUrl, request)
}
const _getV1CustomerSegmentGeneratePdf = async (url: string, request: Types.GetV1CustomerSegmentGeneratePdfRequest): Promise<Types.GetV1CustomerSegmentGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1CustomerSegmentGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-segment/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CustomerSegmentGeneratePdf: Api['getV1CustomerSegmentGeneratePdf'] = async (request: Types.GetV1CustomerSegmentGeneratePdfRequest): Promise<Types.GetV1CustomerSegmentGeneratePdfResponses> => {
  return await _getV1CustomerSegmentGeneratePdf(baseUrl, request)
}
const _getV1FileUpload = async (url: string, request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  const queryParameters: (keyof Types.GetV1FileUploadRequest)[]  = ['key', 'mimeType', 'partCount']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['file-size'] !== undefined) {
    headers['file-size'] = request['file-size']
    delete request['file-size']
  }

  const response = await fetch(`${url}/v1/file-upload/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1FileUpload: Api['getV1FileUpload'] = async (request: Types.GetV1FileUploadRequest): Promise<Types.GetV1FileUploadResponses> => {
  return await _getV1FileUpload(baseUrl, request)
}
const _postV1FileUploadMarkComplete = async (url: string, request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/file-upload/mark-complete`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1FileUploadMarkComplete: Api['postV1FileUploadMarkComplete'] = async (request: Types.PostV1FileUploadMarkCompleteRequest): Promise<Types.PostV1FileUploadMarkCompleteResponses> => {
  return await _postV1FileUploadMarkComplete(baseUrl, request)
}
const _getV1Promotion = async (url: string, request: Types.GetV1PromotionRequest): Promise<Types.GetV1PromotionResponses> => {
  const queryParameters: (keyof Types.GetV1PromotionRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Promotion: Api['getV1Promotion'] = async (request: Types.GetV1PromotionRequest): Promise<Types.GetV1PromotionResponses> => {
  return await _getV1Promotion(baseUrl, request)
}
const _postV1Promotion = async (url: string, request: Types.PostV1PromotionRequest): Promise<Types.PostV1PromotionResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Promotion: Api['postV1Promotion'] = async (request: Types.PostV1PromotionRequest): Promise<Types.PostV1PromotionResponses> => {
  return await _postV1Promotion(baseUrl, request)
}
const _postV1PromotionSaveAsDraft = async (url: string, request: Types.PostV1PromotionSaveAsDraftRequest): Promise<Types.PostV1PromotionSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PromotionSaveAsDraft: Api['postV1PromotionSaveAsDraft'] = async (request: Types.PostV1PromotionSaveAsDraftRequest): Promise<Types.PostV1PromotionSaveAsDraftResponses> => {
  return await _postV1PromotionSaveAsDraft(baseUrl, request)
}
const _getV1PromotionId = async (url: string, request: Types.GetV1PromotionIdRequest): Promise<Types.GetV1PromotionIdResponses> => {
  const queryParameters: (keyof Types.GetV1PromotionIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PromotionId: Api['getV1PromotionId'] = async (request: Types.GetV1PromotionIdRequest): Promise<Types.GetV1PromotionIdResponses> => {
  return await _getV1PromotionId(baseUrl, request)
}
const _putV1PromotionId = async (url: string, request: Types.PutV1PromotionIdRequest): Promise<Types.PutV1PromotionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PromotionId: Api['putV1PromotionId'] = async (request: Types.PutV1PromotionIdRequest): Promise<Types.PutV1PromotionIdResponses> => {
  return await _putV1PromotionId(baseUrl, request)
}
const _deleteV1PromotionId = async (url: string, request: Types.DeleteV1PromotionIdRequest): Promise<Types.DeleteV1PromotionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PromotionId: Api['deleteV1PromotionId'] = async (request: Types.DeleteV1PromotionIdRequest): Promise<Types.DeleteV1PromotionIdResponses> => {
  return await _deleteV1PromotionId(baseUrl, request)
}
const _postV1PromotionCoupon = async (url: string, request: Types.PostV1PromotionCouponRequest): Promise<Types.PostV1PromotionCouponResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/coupon/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PromotionCoupon: Api['postV1PromotionCoupon'] = async (request: Types.PostV1PromotionCouponRequest): Promise<Types.PostV1PromotionCouponResponses> => {
  return await _postV1PromotionCoupon(baseUrl, request)
}
const _getV1PromotionCoupon = async (url: string, request: Types.GetV1PromotionCouponRequest): Promise<Types.GetV1PromotionCouponResponses> => {
  const queryParameters: (keyof Types.GetV1PromotionCouponRequest)[]  = ['promotionId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/coupon/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PromotionCoupon: Api['getV1PromotionCoupon'] = async (request: Types.GetV1PromotionCouponRequest): Promise<Types.GetV1PromotionCouponResponses> => {
  return await _getV1PromotionCoupon(baseUrl, request)
}
const _getV1PromotionCouponId = async (url: string, request: Types.GetV1PromotionCouponIdRequest): Promise<Types.GetV1PromotionCouponIdResponses> => {
  const queryParameters: (keyof Types.GetV1PromotionCouponIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/coupon/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PromotionCouponId: Api['getV1PromotionCouponId'] = async (request: Types.GetV1PromotionCouponIdRequest): Promise<Types.GetV1PromotionCouponIdResponses> => {
  return await _getV1PromotionCouponId(baseUrl, request)
}
const _deleteV1PromotionCouponId = async (url: string, request: Types.DeleteV1PromotionCouponIdRequest): Promise<Types.DeleteV1PromotionCouponIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/coupon/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PromotionCouponId: Api['deleteV1PromotionCouponId'] = async (request: Types.DeleteV1PromotionCouponIdRequest): Promise<Types.DeleteV1PromotionCouponIdResponses> => {
  return await _deleteV1PromotionCouponId(baseUrl, request)
}
const _putV1PromotionCouponId = async (url: string, request: Types.PutV1PromotionCouponIdRequest): Promise<Types.PutV1PromotionCouponIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/coupon/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PromotionCouponId: Api['putV1PromotionCouponId'] = async (request: Types.PutV1PromotionCouponIdRequest): Promise<Types.PutV1PromotionCouponIdResponses> => {
  return await _putV1PromotionCouponId(baseUrl, request)
}
const _postV1PromotionReward = async (url: string, request: Types.PostV1PromotionRewardRequest): Promise<Types.PostV1PromotionRewardResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/reward/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PromotionReward: Api['postV1PromotionReward'] = async (request: Types.PostV1PromotionRewardRequest): Promise<Types.PostV1PromotionRewardResponses> => {
  return await _postV1PromotionReward(baseUrl, request)
}
const _getV1PromotionReward = async (url: string, request: Types.GetV1PromotionRewardRequest): Promise<Types.GetV1PromotionRewardResponses> => {
  const queryParameters: (keyof Types.GetV1PromotionRewardRequest)[]  = ['promotionId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/reward/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PromotionReward: Api['getV1PromotionReward'] = async (request: Types.GetV1PromotionRewardRequest): Promise<Types.GetV1PromotionRewardResponses> => {
  return await _getV1PromotionReward(baseUrl, request)
}
const _getV1PromotionRewardId = async (url: string, request: Types.GetV1PromotionRewardIdRequest): Promise<Types.GetV1PromotionRewardIdResponses> => {
  const queryParameters: (keyof Types.GetV1PromotionRewardIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/reward/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PromotionRewardId: Api['getV1PromotionRewardId'] = async (request: Types.GetV1PromotionRewardIdRequest): Promise<Types.GetV1PromotionRewardIdResponses> => {
  return await _getV1PromotionRewardId(baseUrl, request)
}
const _deleteV1PromotionRewardId = async (url: string, request: Types.DeleteV1PromotionRewardIdRequest): Promise<Types.DeleteV1PromotionRewardIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/reward/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1PromotionRewardId: Api['deleteV1PromotionRewardId'] = async (request: Types.DeleteV1PromotionRewardIdRequest): Promise<Types.DeleteV1PromotionRewardIdResponses> => {
  return await _deleteV1PromotionRewardId(baseUrl, request)
}
const _putV1PromotionRewardId = async (url: string, request: Types.PutV1PromotionRewardIdRequest): Promise<Types.PutV1PromotionRewardIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/reward/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1PromotionRewardId: Api['putV1PromotionRewardId'] = async (request: Types.PutV1PromotionRewardIdRequest): Promise<Types.PutV1PromotionRewardIdResponses> => {
  return await _putV1PromotionRewardId(baseUrl, request)
}
const _getV1PromotionGenerateExcel = async (url: string, request: Types.GetV1PromotionGenerateExcelRequest): Promise<Types.GetV1PromotionGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1PromotionGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PromotionGenerateExcel: Api['getV1PromotionGenerateExcel'] = async (request: Types.GetV1PromotionGenerateExcelRequest): Promise<Types.GetV1PromotionGenerateExcelResponses> => {
  return await _getV1PromotionGenerateExcel(baseUrl, request)
}
const _postV1PromotionImport = async (url: string, request: Types.PostV1PromotionImportRequest): Promise<Types.PostV1PromotionImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1PromotionImport: Api['postV1PromotionImport'] = async (request: Types.PostV1PromotionImportRequest): Promise<Types.PostV1PromotionImportResponses> => {
  return await _postV1PromotionImport(baseUrl, request)
}
const _getV1PromotionGeneratePdf = async (url: string, request: Types.GetV1PromotionGeneratePdfRequest): Promise<Types.GetV1PromotionGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1PromotionGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/promotion/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1PromotionGeneratePdf: Api['getV1PromotionGeneratePdf'] = async (request: Types.GetV1PromotionGeneratePdfRequest): Promise<Types.GetV1PromotionGeneratePdfResponses> => {
  return await _getV1PromotionGeneratePdf(baseUrl, request)
}
const _getV1Lead = async (url: string, request: Types.GetV1LeadRequest): Promise<Types.GetV1LeadResponses> => {
  const queryParameters: (keyof Types.GetV1LeadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Lead: Api['getV1Lead'] = async (request: Types.GetV1LeadRequest): Promise<Types.GetV1LeadResponses> => {
  return await _getV1Lead(baseUrl, request)
}
const _postV1Lead = async (url: string, request: Types.PostV1LeadRequest): Promise<Types.PostV1LeadResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Lead: Api['postV1Lead'] = async (request: Types.PostV1LeadRequest): Promise<Types.PostV1LeadResponses> => {
  return await _postV1Lead(baseUrl, request)
}
const _postV1LeadCheck = async (url: string, request: Types.PostV1LeadCheckRequest): Promise<Types.PostV1LeadCheckResponses> => {
  const queryParameters: (keyof Types.PostV1LeadCheckRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/check?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LeadCheck: Api['postV1LeadCheck'] = async (request: Types.PostV1LeadCheckRequest): Promise<Types.PostV1LeadCheckResponses> => {
  return await _postV1LeadCheck(baseUrl, request)
}
const _postV1LeadSaveAsDraft = async (url: string, request: Types.PostV1LeadSaveAsDraftRequest): Promise<Types.PostV1LeadSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LeadSaveAsDraft: Api['postV1LeadSaveAsDraft'] = async (request: Types.PostV1LeadSaveAsDraftRequest): Promise<Types.PostV1LeadSaveAsDraftResponses> => {
  return await _postV1LeadSaveAsDraft(baseUrl, request)
}
const _getV1LeadId = async (url: string, request: Types.GetV1LeadIdRequest): Promise<Types.GetV1LeadIdResponses> => {
  const queryParameters: (keyof Types.GetV1LeadIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeadId: Api['getV1LeadId'] = async (request: Types.GetV1LeadIdRequest): Promise<Types.GetV1LeadIdResponses> => {
  return await _getV1LeadId(baseUrl, request)
}
const _putV1LeadId = async (url: string, request: Types.PutV1LeadIdRequest): Promise<Types.PutV1LeadIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1LeadId: Api['putV1LeadId'] = async (request: Types.PutV1LeadIdRequest): Promise<Types.PutV1LeadIdResponses> => {
  return await _putV1LeadId(baseUrl, request)
}
const _deleteV1LeadId = async (url: string, request: Types.DeleteV1LeadIdRequest): Promise<Types.DeleteV1LeadIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1LeadId: Api['deleteV1LeadId'] = async (request: Types.DeleteV1LeadIdRequest): Promise<Types.DeleteV1LeadIdResponses> => {
  return await _deleteV1LeadId(baseUrl, request)
}
const _patchV1LeadLeadStatusId = async (url: string, request: Types.PatchV1LeadLeadStatusIdRequest): Promise<Types.PatchV1LeadLeadStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/lead-status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1LeadLeadStatusId: Api['patchV1LeadLeadStatusId'] = async (request: Types.PatchV1LeadLeadStatusIdRequest): Promise<Types.PatchV1LeadLeadStatusIdResponses> => {
  return await _patchV1LeadLeadStatusId(baseUrl, request)
}
const _patchV1LeadLeadToOpportunityId = async (url: string, request: Types.PatchV1LeadLeadToOpportunityIdRequest): Promise<Types.PatchV1LeadLeadToOpportunityIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/lead-to-opportunity/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1LeadLeadToOpportunityId: Api['patchV1LeadLeadToOpportunityId'] = async (request: Types.PatchV1LeadLeadToOpportunityIdRequest): Promise<Types.PatchV1LeadLeadToOpportunityIdResponses> => {
  return await _patchV1LeadLeadToOpportunityId(baseUrl, request)
}
const _postV1LeadFollowup = async (url: string, request: Types.PostV1LeadFollowupRequest): Promise<Types.PostV1LeadFollowupResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/followup/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LeadFollowup: Api['postV1LeadFollowup'] = async (request: Types.PostV1LeadFollowupRequest): Promise<Types.PostV1LeadFollowupResponses> => {
  return await _postV1LeadFollowup(baseUrl, request)
}
const _getV1LeadFollowup = async (url: string, request: Types.GetV1LeadFollowupRequest): Promise<Types.GetV1LeadFollowupResponses> => {
  const queryParameters: (keyof Types.GetV1LeadFollowupRequest)[]  = ['partyId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/followup/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeadFollowup: Api['getV1LeadFollowup'] = async (request: Types.GetV1LeadFollowupRequest): Promise<Types.GetV1LeadFollowupResponses> => {
  return await _getV1LeadFollowup(baseUrl, request)
}
const _getV1LeadFollowupId = async (url: string, request: Types.GetV1LeadFollowupIdRequest): Promise<Types.GetV1LeadFollowupIdResponses> => {
  const queryParameters: (keyof Types.GetV1LeadFollowupIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/followup/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeadFollowupId: Api['getV1LeadFollowupId'] = async (request: Types.GetV1LeadFollowupIdRequest): Promise<Types.GetV1LeadFollowupIdResponses> => {
  return await _getV1LeadFollowupId(baseUrl, request)
}
const _deleteV1LeadFollowupId = async (url: string, request: Types.DeleteV1LeadFollowupIdRequest): Promise<Types.DeleteV1LeadFollowupIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/followup/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1LeadFollowupId: Api['deleteV1LeadFollowupId'] = async (request: Types.DeleteV1LeadFollowupIdRequest): Promise<Types.DeleteV1LeadFollowupIdResponses> => {
  return await _deleteV1LeadFollowupId(baseUrl, request)
}
const _putV1LeadFollowupId = async (url: string, request: Types.PutV1LeadFollowupIdRequest): Promise<Types.PutV1LeadFollowupIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/followup/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1LeadFollowupId: Api['putV1LeadFollowupId'] = async (request: Types.PutV1LeadFollowupIdRequest): Promise<Types.PutV1LeadFollowupIdResponses> => {
  return await _putV1LeadFollowupId(baseUrl, request)
}
const _postV1LeadCommunicationLog = async (url: string, request: Types.PostV1LeadCommunicationLogRequest): Promise<Types.PostV1LeadCommunicationLogResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/communication-log/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LeadCommunicationLog: Api['postV1LeadCommunicationLog'] = async (request: Types.PostV1LeadCommunicationLogRequest): Promise<Types.PostV1LeadCommunicationLogResponses> => {
  return await _postV1LeadCommunicationLog(baseUrl, request)
}
const _getV1LeadCommunicationLog = async (url: string, request: Types.GetV1LeadCommunicationLogRequest): Promise<Types.GetV1LeadCommunicationLogResponses> => {
  const queryParameters: (keyof Types.GetV1LeadCommunicationLogRequest)[]  = ['partyId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/communication-log/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeadCommunicationLog: Api['getV1LeadCommunicationLog'] = async (request: Types.GetV1LeadCommunicationLogRequest): Promise<Types.GetV1LeadCommunicationLogResponses> => {
  return await _getV1LeadCommunicationLog(baseUrl, request)
}
const _getV1LeadCommunicationLogId = async (url: string, request: Types.GetV1LeadCommunicationLogIdRequest): Promise<Types.GetV1LeadCommunicationLogIdResponses> => {
  const queryParameters: (keyof Types.GetV1LeadCommunicationLogIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/communication-log/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeadCommunicationLogId: Api['getV1LeadCommunicationLogId'] = async (request: Types.GetV1LeadCommunicationLogIdRequest): Promise<Types.GetV1LeadCommunicationLogIdResponses> => {
  return await _getV1LeadCommunicationLogId(baseUrl, request)
}
const _deleteV1LeadCommunicationLogId = async (url: string, request: Types.DeleteV1LeadCommunicationLogIdRequest): Promise<Types.DeleteV1LeadCommunicationLogIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/communication-log/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1LeadCommunicationLogId: Api['deleteV1LeadCommunicationLogId'] = async (request: Types.DeleteV1LeadCommunicationLogIdRequest): Promise<Types.DeleteV1LeadCommunicationLogIdResponses> => {
  return await _deleteV1LeadCommunicationLogId(baseUrl, request)
}
const _putV1LeadCommunicationLogId = async (url: string, request: Types.PutV1LeadCommunicationLogIdRequest): Promise<Types.PutV1LeadCommunicationLogIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/communication-log/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1LeadCommunicationLogId: Api['putV1LeadCommunicationLogId'] = async (request: Types.PutV1LeadCommunicationLogIdRequest): Promise<Types.PutV1LeadCommunicationLogIdResponses> => {
  return await _putV1LeadCommunicationLogId(baseUrl, request)
}
const _postV1LeadAddress = async (url: string, request: Types.PostV1LeadAddressRequest): Promise<Types.PostV1LeadAddressResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/address/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LeadAddress: Api['postV1LeadAddress'] = async (request: Types.PostV1LeadAddressRequest): Promise<Types.PostV1LeadAddressResponses> => {
  return await _postV1LeadAddress(baseUrl, request)
}
const _getV1LeadAddress = async (url: string, request: Types.GetV1LeadAddressRequest): Promise<Types.GetV1LeadAddressResponses> => {
  const queryParameters: (keyof Types.GetV1LeadAddressRequest)[]  = ['leadId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/address/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeadAddress: Api['getV1LeadAddress'] = async (request: Types.GetV1LeadAddressRequest): Promise<Types.GetV1LeadAddressResponses> => {
  return await _getV1LeadAddress(baseUrl, request)
}
const _getV1LeadAddressId = async (url: string, request: Types.GetV1LeadAddressIdRequest): Promise<Types.GetV1LeadAddressIdResponses> => {
  const queryParameters: (keyof Types.GetV1LeadAddressIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/address/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeadAddressId: Api['getV1LeadAddressId'] = async (request: Types.GetV1LeadAddressIdRequest): Promise<Types.GetV1LeadAddressIdResponses> => {
  return await _getV1LeadAddressId(baseUrl, request)
}
const _deleteV1LeadAddressId = async (url: string, request: Types.DeleteV1LeadAddressIdRequest): Promise<Types.DeleteV1LeadAddressIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/address/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1LeadAddressId: Api['deleteV1LeadAddressId'] = async (request: Types.DeleteV1LeadAddressIdRequest): Promise<Types.DeleteV1LeadAddressIdResponses> => {
  return await _deleteV1LeadAddressId(baseUrl, request)
}
const _putV1LeadAddressId = async (url: string, request: Types.PutV1LeadAddressIdRequest): Promise<Types.PutV1LeadAddressIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/address/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1LeadAddressId: Api['putV1LeadAddressId'] = async (request: Types.PutV1LeadAddressIdRequest): Promise<Types.PutV1LeadAddressIdResponses> => {
  return await _putV1LeadAddressId(baseUrl, request)
}
const _postV1LeadContact = async (url: string, request: Types.PostV1LeadContactRequest): Promise<Types.PostV1LeadContactResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/contact/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LeadContact: Api['postV1LeadContact'] = async (request: Types.PostV1LeadContactRequest): Promise<Types.PostV1LeadContactResponses> => {
  return await _postV1LeadContact(baseUrl, request)
}
const _getV1LeadContact = async (url: string, request: Types.GetV1LeadContactRequest): Promise<Types.GetV1LeadContactResponses> => {
  const queryParameters: (keyof Types.GetV1LeadContactRequest)[]  = ['leadId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/contact/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeadContact: Api['getV1LeadContact'] = async (request: Types.GetV1LeadContactRequest): Promise<Types.GetV1LeadContactResponses> => {
  return await _getV1LeadContact(baseUrl, request)
}
const _getV1LeadContactId = async (url: string, request: Types.GetV1LeadContactIdRequest): Promise<Types.GetV1LeadContactIdResponses> => {
  const queryParameters: (keyof Types.GetV1LeadContactIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/contact/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeadContactId: Api['getV1LeadContactId'] = async (request: Types.GetV1LeadContactIdRequest): Promise<Types.GetV1LeadContactIdResponses> => {
  return await _getV1LeadContactId(baseUrl, request)
}
const _deleteV1LeadContactId = async (url: string, request: Types.DeleteV1LeadContactIdRequest): Promise<Types.DeleteV1LeadContactIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/contact/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1LeadContactId: Api['deleteV1LeadContactId'] = async (request: Types.DeleteV1LeadContactIdRequest): Promise<Types.DeleteV1LeadContactIdResponses> => {
  return await _deleteV1LeadContactId(baseUrl, request)
}
const _putV1LeadContactId = async (url: string, request: Types.PutV1LeadContactIdRequest): Promise<Types.PutV1LeadContactIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/contact/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1LeadContactId: Api['putV1LeadContactId'] = async (request: Types.PutV1LeadContactIdRequest): Promise<Types.PutV1LeadContactIdResponses> => {
  return await _putV1LeadContactId(baseUrl, request)
}
const _getV1LeadIdDownload = async (url: string, request: Types.GetV1LeadIdDownloadRequest): Promise<Types.GetV1LeadIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1LeadIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeadIdDownload: Api['getV1LeadIdDownload'] = async (request: Types.GetV1LeadIdDownloadRequest): Promise<Types.GetV1LeadIdDownloadResponses> => {
  return await _getV1LeadIdDownload(baseUrl, request)
}
const _getV1LeadIdSendEmail = async (url: string, request: Types.GetV1LeadIdSendEmailRequest): Promise<Types.GetV1LeadIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1LeadIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeadIdSendEmail: Api['getV1LeadIdSendEmail'] = async (request: Types.GetV1LeadIdSendEmailRequest): Promise<Types.GetV1LeadIdSendEmailResponses> => {
  return await _getV1LeadIdSendEmail(baseUrl, request)
}
const _getV1LeadGenerateExcel = async (url: string, request: Types.GetV1LeadGenerateExcelRequest): Promise<Types.GetV1LeadGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1LeadGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeadGenerateExcel: Api['getV1LeadGenerateExcel'] = async (request: Types.GetV1LeadGenerateExcelRequest): Promise<Types.GetV1LeadGenerateExcelResponses> => {
  return await _getV1LeadGenerateExcel(baseUrl, request)
}
const _postV1LeadImport = async (url: string, request: Types.PostV1LeadImportRequest): Promise<Types.PostV1LeadImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1LeadImport: Api['postV1LeadImport'] = async (request: Types.PostV1LeadImportRequest): Promise<Types.PostV1LeadImportResponses> => {
  return await _postV1LeadImport(baseUrl, request)
}
const _getV1LeadGeneratePdf = async (url: string, request: Types.GetV1LeadGeneratePdfRequest): Promise<Types.GetV1LeadGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1LeadGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/lead/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1LeadGeneratePdf: Api['getV1LeadGeneratePdf'] = async (request: Types.GetV1LeadGeneratePdfRequest): Promise<Types.GetV1LeadGeneratePdfResponses> => {
  return await _getV1LeadGeneratePdf(baseUrl, request)
}
const _postV1OpportunityPromotionCheck = async (url: string, request: Types.PostV1OpportunityPromotionCheckRequest): Promise<Types.PostV1OpportunityPromotionCheckResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/promotion/check/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OpportunityPromotionCheck: Api['postV1OpportunityPromotionCheck'] = async (request: Types.PostV1OpportunityPromotionCheckRequest): Promise<Types.PostV1OpportunityPromotionCheckResponses> => {
  return await _postV1OpportunityPromotionCheck(baseUrl, request)
}
const _postV1OpportunityPromotionApply = async (url: string, request: Types.PostV1OpportunityPromotionApplyRequest): Promise<Types.PostV1OpportunityPromotionApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/promotion/apply/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OpportunityPromotionApply: Api['postV1OpportunityPromotionApply'] = async (request: Types.PostV1OpportunityPromotionApplyRequest): Promise<Types.PostV1OpportunityPromotionApplyResponses> => {
  return await _postV1OpportunityPromotionApply(baseUrl, request)
}
const _postV1OpportunityPromotionItemApply = async (url: string, request: Types.PostV1OpportunityPromotionItemApplyRequest): Promise<Types.PostV1OpportunityPromotionItemApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/promotion/item/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OpportunityPromotionItemApply: Api['postV1OpportunityPromotionItemApply'] = async (request: Types.PostV1OpportunityPromotionItemApplyRequest): Promise<Types.PostV1OpportunityPromotionItemApplyResponses> => {
  return await _postV1OpportunityPromotionItemApply(baseUrl, request)
}
const _deleteV1OpportunityPromotionId = async (url: string, request: Types.DeleteV1OpportunityPromotionIdRequest): Promise<Types.DeleteV1OpportunityPromotionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/promotion/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1OpportunityPromotionId: Api['deleteV1OpportunityPromotionId'] = async (request: Types.DeleteV1OpportunityPromotionIdRequest): Promise<Types.DeleteV1OpportunityPromotionIdResponses> => {
  return await _deleteV1OpportunityPromotionId(baseUrl, request)
}
const _getV1Opportunity = async (url: string, request: Types.GetV1OpportunityRequest): Promise<Types.GetV1OpportunityResponses> => {
  const queryParameters: (keyof Types.GetV1OpportunityRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Opportunity: Api['getV1Opportunity'] = async (request: Types.GetV1OpportunityRequest): Promise<Types.GetV1OpportunityResponses> => {
  return await _getV1Opportunity(baseUrl, request)
}
const _postV1Opportunity = async (url: string, request: Types.PostV1OpportunityRequest): Promise<Types.PostV1OpportunityResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Opportunity: Api['postV1Opportunity'] = async (request: Types.PostV1OpportunityRequest): Promise<Types.PostV1OpportunityResponses> => {
  return await _postV1Opportunity(baseUrl, request)
}
const _postV1OpportunitySaveAsDraft = async (url: string, request: Types.PostV1OpportunitySaveAsDraftRequest): Promise<Types.PostV1OpportunitySaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OpportunitySaveAsDraft: Api['postV1OpportunitySaveAsDraft'] = async (request: Types.PostV1OpportunitySaveAsDraftRequest): Promise<Types.PostV1OpportunitySaveAsDraftResponses> => {
  return await _postV1OpportunitySaveAsDraft(baseUrl, request)
}
const _getV1OpportunityId = async (url: string, request: Types.GetV1OpportunityIdRequest): Promise<Types.GetV1OpportunityIdResponses> => {
  const queryParameters: (keyof Types.GetV1OpportunityIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OpportunityId: Api['getV1OpportunityId'] = async (request: Types.GetV1OpportunityIdRequest): Promise<Types.GetV1OpportunityIdResponses> => {
  return await _getV1OpportunityId(baseUrl, request)
}
const _putV1OpportunityId = async (url: string, request: Types.PutV1OpportunityIdRequest): Promise<Types.PutV1OpportunityIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1OpportunityId: Api['putV1OpportunityId'] = async (request: Types.PutV1OpportunityIdRequest): Promise<Types.PutV1OpportunityIdResponses> => {
  return await _putV1OpportunityId(baseUrl, request)
}
const _deleteV1OpportunityId = async (url: string, request: Types.DeleteV1OpportunityIdRequest): Promise<Types.DeleteV1OpportunityIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1OpportunityId: Api['deleteV1OpportunityId'] = async (request: Types.DeleteV1OpportunityIdRequest): Promise<Types.DeleteV1OpportunityIdResponses> => {
  return await _deleteV1OpportunityId(baseUrl, request)
}
const _patchV1OpportunityStageId = async (url: string, request: Types.PatchV1OpportunityStageIdRequest): Promise<Types.PatchV1OpportunityStageIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/stage/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1OpportunityStageId: Api['patchV1OpportunityStageId'] = async (request: Types.PatchV1OpportunityStageIdRequest): Promise<Types.PatchV1OpportunityStageIdResponses> => {
  return await _patchV1OpportunityStageId(baseUrl, request)
}
const _postV1OpportunityFollowup = async (url: string, request: Types.PostV1OpportunityFollowupRequest): Promise<Types.PostV1OpportunityFollowupResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/followup/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OpportunityFollowup: Api['postV1OpportunityFollowup'] = async (request: Types.PostV1OpportunityFollowupRequest): Promise<Types.PostV1OpportunityFollowupResponses> => {
  return await _postV1OpportunityFollowup(baseUrl, request)
}
const _getV1OpportunityFollowup = async (url: string, request: Types.GetV1OpportunityFollowupRequest): Promise<Types.GetV1OpportunityFollowupResponses> => {
  const queryParameters: (keyof Types.GetV1OpportunityFollowupRequest)[]  = ['opportunityId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/followup/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OpportunityFollowup: Api['getV1OpportunityFollowup'] = async (request: Types.GetV1OpportunityFollowupRequest): Promise<Types.GetV1OpportunityFollowupResponses> => {
  return await _getV1OpportunityFollowup(baseUrl, request)
}
const _getV1OpportunityFollowupId = async (url: string, request: Types.GetV1OpportunityFollowupIdRequest): Promise<Types.GetV1OpportunityFollowupIdResponses> => {
  const queryParameters: (keyof Types.GetV1OpportunityFollowupIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/followup/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OpportunityFollowupId: Api['getV1OpportunityFollowupId'] = async (request: Types.GetV1OpportunityFollowupIdRequest): Promise<Types.GetV1OpportunityFollowupIdResponses> => {
  return await _getV1OpportunityFollowupId(baseUrl, request)
}
const _deleteV1OpportunityFollowupId = async (url: string, request: Types.DeleteV1OpportunityFollowupIdRequest): Promise<Types.DeleteV1OpportunityFollowupIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/followup/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1OpportunityFollowupId: Api['deleteV1OpportunityFollowupId'] = async (request: Types.DeleteV1OpportunityFollowupIdRequest): Promise<Types.DeleteV1OpportunityFollowupIdResponses> => {
  return await _deleteV1OpportunityFollowupId(baseUrl, request)
}
const _putV1OpportunityFollowupId = async (url: string, request: Types.PutV1OpportunityFollowupIdRequest): Promise<Types.PutV1OpportunityFollowupIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/followup/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1OpportunityFollowupId: Api['putV1OpportunityFollowupId'] = async (request: Types.PutV1OpportunityFollowupIdRequest): Promise<Types.PutV1OpportunityFollowupIdResponses> => {
  return await _putV1OpportunityFollowupId(baseUrl, request)
}
const _postV1OpportunityCommunicationLog = async (url: string, request: Types.PostV1OpportunityCommunicationLogRequest): Promise<Types.PostV1OpportunityCommunicationLogResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/communication-log/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OpportunityCommunicationLog: Api['postV1OpportunityCommunicationLog'] = async (request: Types.PostV1OpportunityCommunicationLogRequest): Promise<Types.PostV1OpportunityCommunicationLogResponses> => {
  return await _postV1OpportunityCommunicationLog(baseUrl, request)
}
const _getV1OpportunityCommunicationLog = async (url: string, request: Types.GetV1OpportunityCommunicationLogRequest): Promise<Types.GetV1OpportunityCommunicationLogResponses> => {
  const queryParameters: (keyof Types.GetV1OpportunityCommunicationLogRequest)[]  = ['opportunityId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/communication-log/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OpportunityCommunicationLog: Api['getV1OpportunityCommunicationLog'] = async (request: Types.GetV1OpportunityCommunicationLogRequest): Promise<Types.GetV1OpportunityCommunicationLogResponses> => {
  return await _getV1OpportunityCommunicationLog(baseUrl, request)
}
const _getV1OpportunityCommunicationLogId = async (url: string, request: Types.GetV1OpportunityCommunicationLogIdRequest): Promise<Types.GetV1OpportunityCommunicationLogIdResponses> => {
  const queryParameters: (keyof Types.GetV1OpportunityCommunicationLogIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/communication-log/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OpportunityCommunicationLogId: Api['getV1OpportunityCommunicationLogId'] = async (request: Types.GetV1OpportunityCommunicationLogIdRequest): Promise<Types.GetV1OpportunityCommunicationLogIdResponses> => {
  return await _getV1OpportunityCommunicationLogId(baseUrl, request)
}
const _deleteV1OpportunityCommunicationLogId = async (url: string, request: Types.DeleteV1OpportunityCommunicationLogIdRequest): Promise<Types.DeleteV1OpportunityCommunicationLogIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/communication-log/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1OpportunityCommunicationLogId: Api['deleteV1OpportunityCommunicationLogId'] = async (request: Types.DeleteV1OpportunityCommunicationLogIdRequest): Promise<Types.DeleteV1OpportunityCommunicationLogIdResponses> => {
  return await _deleteV1OpportunityCommunicationLogId(baseUrl, request)
}
const _putV1OpportunityCommunicationLogId = async (url: string, request: Types.PutV1OpportunityCommunicationLogIdRequest): Promise<Types.PutV1OpportunityCommunicationLogIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/communication-log/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1OpportunityCommunicationLogId: Api['putV1OpportunityCommunicationLogId'] = async (request: Types.PutV1OpportunityCommunicationLogIdRequest): Promise<Types.PutV1OpportunityCommunicationLogIdResponses> => {
  return await _putV1OpportunityCommunicationLogId(baseUrl, request)
}
const _postV1OpportunityAddress = async (url: string, request: Types.PostV1OpportunityAddressRequest): Promise<Types.PostV1OpportunityAddressResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/address/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OpportunityAddress: Api['postV1OpportunityAddress'] = async (request: Types.PostV1OpportunityAddressRequest): Promise<Types.PostV1OpportunityAddressResponses> => {
  return await _postV1OpportunityAddress(baseUrl, request)
}
const _getV1OpportunityAddress = async (url: string, request: Types.GetV1OpportunityAddressRequest): Promise<Types.GetV1OpportunityAddressResponses> => {
  const queryParameters: (keyof Types.GetV1OpportunityAddressRequest)[]  = ['opportunityId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/address/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OpportunityAddress: Api['getV1OpportunityAddress'] = async (request: Types.GetV1OpportunityAddressRequest): Promise<Types.GetV1OpportunityAddressResponses> => {
  return await _getV1OpportunityAddress(baseUrl, request)
}
const _getV1OpportunityAddressId = async (url: string, request: Types.GetV1OpportunityAddressIdRequest): Promise<Types.GetV1OpportunityAddressIdResponses> => {
  const queryParameters: (keyof Types.GetV1OpportunityAddressIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/address/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OpportunityAddressId: Api['getV1OpportunityAddressId'] = async (request: Types.GetV1OpportunityAddressIdRequest): Promise<Types.GetV1OpportunityAddressIdResponses> => {
  return await _getV1OpportunityAddressId(baseUrl, request)
}
const _deleteV1OpportunityAddressId = async (url: string, request: Types.DeleteV1OpportunityAddressIdRequest): Promise<Types.DeleteV1OpportunityAddressIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/address/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1OpportunityAddressId: Api['deleteV1OpportunityAddressId'] = async (request: Types.DeleteV1OpportunityAddressIdRequest): Promise<Types.DeleteV1OpportunityAddressIdResponses> => {
  return await _deleteV1OpportunityAddressId(baseUrl, request)
}
const _putV1OpportunityAddressId = async (url: string, request: Types.PutV1OpportunityAddressIdRequest): Promise<Types.PutV1OpportunityAddressIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/address/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1OpportunityAddressId: Api['putV1OpportunityAddressId'] = async (request: Types.PutV1OpportunityAddressIdRequest): Promise<Types.PutV1OpportunityAddressIdResponses> => {
  return await _putV1OpportunityAddressId(baseUrl, request)
}
const _postV1OpportunityContact = async (url: string, request: Types.PostV1OpportunityContactRequest): Promise<Types.PostV1OpportunityContactResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/contact/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OpportunityContact: Api['postV1OpportunityContact'] = async (request: Types.PostV1OpportunityContactRequest): Promise<Types.PostV1OpportunityContactResponses> => {
  return await _postV1OpportunityContact(baseUrl, request)
}
const _getV1OpportunityContact = async (url: string, request: Types.GetV1OpportunityContactRequest): Promise<Types.GetV1OpportunityContactResponses> => {
  const queryParameters: (keyof Types.GetV1OpportunityContactRequest)[]  = ['opportunityId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/contact/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OpportunityContact: Api['getV1OpportunityContact'] = async (request: Types.GetV1OpportunityContactRequest): Promise<Types.GetV1OpportunityContactResponses> => {
  return await _getV1OpportunityContact(baseUrl, request)
}
const _getV1OpportunityContactId = async (url: string, request: Types.GetV1OpportunityContactIdRequest): Promise<Types.GetV1OpportunityContactIdResponses> => {
  const queryParameters: (keyof Types.GetV1OpportunityContactIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/contact/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OpportunityContactId: Api['getV1OpportunityContactId'] = async (request: Types.GetV1OpportunityContactIdRequest): Promise<Types.GetV1OpportunityContactIdResponses> => {
  return await _getV1OpportunityContactId(baseUrl, request)
}
const _deleteV1OpportunityContactId = async (url: string, request: Types.DeleteV1OpportunityContactIdRequest): Promise<Types.DeleteV1OpportunityContactIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/contact/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1OpportunityContactId: Api['deleteV1OpportunityContactId'] = async (request: Types.DeleteV1OpportunityContactIdRequest): Promise<Types.DeleteV1OpportunityContactIdResponses> => {
  return await _deleteV1OpportunityContactId(baseUrl, request)
}
const _putV1OpportunityContactId = async (url: string, request: Types.PutV1OpportunityContactIdRequest): Promise<Types.PutV1OpportunityContactIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/contact/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1OpportunityContactId: Api['putV1OpportunityContactId'] = async (request: Types.PutV1OpportunityContactIdRequest): Promise<Types.PutV1OpportunityContactIdResponses> => {
  return await _putV1OpportunityContactId(baseUrl, request)
}
const _postV1OpportunityItem = async (url: string, request: Types.PostV1OpportunityItemRequest): Promise<Types.PostV1OpportunityItemResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/item/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OpportunityItem: Api['postV1OpportunityItem'] = async (request: Types.PostV1OpportunityItemRequest): Promise<Types.PostV1OpportunityItemResponses> => {
  return await _postV1OpportunityItem(baseUrl, request)
}
const _getV1OpportunityItem = async (url: string, request: Types.GetV1OpportunityItemRequest): Promise<Types.GetV1OpportunityItemResponses> => {
  const queryParameters: (keyof Types.GetV1OpportunityItemRequest)[]  = ['opportunityId', 'skip', 'limit', 'search', 'order']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/item/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OpportunityItem: Api['getV1OpportunityItem'] = async (request: Types.GetV1OpportunityItemRequest): Promise<Types.GetV1OpportunityItemResponses> => {
  return await _getV1OpportunityItem(baseUrl, request)
}
const _getV1OpportunityItemId = async (url: string, request: Types.GetV1OpportunityItemIdRequest): Promise<Types.GetV1OpportunityItemIdResponses> => {
  const queryParameters: (keyof Types.GetV1OpportunityItemIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/item/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OpportunityItemId: Api['getV1OpportunityItemId'] = async (request: Types.GetV1OpportunityItemIdRequest): Promise<Types.GetV1OpportunityItemIdResponses> => {
  return await _getV1OpportunityItemId(baseUrl, request)
}
const _deleteV1OpportunityItemId = async (url: string, request: Types.DeleteV1OpportunityItemIdRequest): Promise<Types.DeleteV1OpportunityItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/item/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1OpportunityItemId: Api['deleteV1OpportunityItemId'] = async (request: Types.DeleteV1OpportunityItemIdRequest): Promise<Types.DeleteV1OpportunityItemIdResponses> => {
  return await _deleteV1OpportunityItemId(baseUrl, request)
}
const _putV1OpportunityItemId = async (url: string, request: Types.PutV1OpportunityItemIdRequest): Promise<Types.PutV1OpportunityItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/item/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1OpportunityItemId: Api['putV1OpportunityItemId'] = async (request: Types.PutV1OpportunityItemIdRequest): Promise<Types.PutV1OpportunityItemIdResponses> => {
  return await _putV1OpportunityItemId(baseUrl, request)
}
const _getV1OpportunitySalesPipeline = async (url: string, request: Types.GetV1OpportunitySalesPipelineRequest): Promise<Types.GetV1OpportunitySalesPipelineResponses> => {
  const queryParameters: (keyof Types.GetV1OpportunitySalesPipelineRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/sales-pipeline?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OpportunitySalesPipeline: Api['getV1OpportunitySalesPipeline'] = async (request: Types.GetV1OpportunitySalesPipelineRequest): Promise<Types.GetV1OpportunitySalesPipelineResponses> => {
  return await _getV1OpportunitySalesPipeline(baseUrl, request)
}
const _getV1OpportunityIdPromotions = async (url: string, request: Types.GetV1OpportunityIdPromotionsRequest): Promise<Types.GetV1OpportunityIdPromotionsResponses> => {
  const queryParameters: (keyof Types.GetV1OpportunityIdPromotionsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/${request['id']}/promotions?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OpportunityIdPromotions: Api['getV1OpportunityIdPromotions'] = async (request: Types.GetV1OpportunityIdPromotionsRequest): Promise<Types.GetV1OpportunityIdPromotionsResponses> => {
  return await _getV1OpportunityIdPromotions(baseUrl, request)
}
const _getV1OpportunityGenerateExcel = async (url: string, request: Types.GetV1OpportunityGenerateExcelRequest): Promise<Types.GetV1OpportunityGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1OpportunityGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OpportunityGenerateExcel: Api['getV1OpportunityGenerateExcel'] = async (request: Types.GetV1OpportunityGenerateExcelRequest): Promise<Types.GetV1OpportunityGenerateExcelResponses> => {
  return await _getV1OpportunityGenerateExcel(baseUrl, request)
}
const _postV1OpportunityImport = async (url: string, request: Types.PostV1OpportunityImportRequest): Promise<Types.PostV1OpportunityImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1OpportunityImport: Api['postV1OpportunityImport'] = async (request: Types.PostV1OpportunityImportRequest): Promise<Types.PostV1OpportunityImportResponses> => {
  return await _postV1OpportunityImport(baseUrl, request)
}
const _getV1OpportunityGeneratePdf = async (url: string, request: Types.GetV1OpportunityGeneratePdfRequest): Promise<Types.GetV1OpportunityGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1OpportunityGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/opportunity/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1OpportunityGeneratePdf: Api['getV1OpportunityGeneratePdf'] = async (request: Types.GetV1OpportunityGeneratePdfRequest): Promise<Types.GetV1OpportunityGeneratePdfResponses> => {
  return await _getV1OpportunityGeneratePdf(baseUrl, request)
}
const _postV1Quotation = async (url: string, request: Types.PostV1QuotationRequest): Promise<Types.PostV1QuotationResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1Quotation: Api['postV1Quotation'] = async (request: Types.PostV1QuotationRequest): Promise<Types.PostV1QuotationResponses> => {
  return await _postV1Quotation(baseUrl, request)
}
const _getV1Quotation = async (url: string, request: Types.GetV1QuotationRequest): Promise<Types.GetV1QuotationResponses> => {
  const queryParameters: (keyof Types.GetV1QuotationRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1Quotation: Api['getV1Quotation'] = async (request: Types.GetV1QuotationRequest): Promise<Types.GetV1QuotationResponses> => {
  return await _getV1Quotation(baseUrl, request)
}
const _getV1QuotationId = async (url: string, request: Types.GetV1QuotationIdRequest): Promise<Types.GetV1QuotationIdResponses> => {
  const queryParameters: (keyof Types.GetV1QuotationIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1QuotationId: Api['getV1QuotationId'] = async (request: Types.GetV1QuotationIdRequest): Promise<Types.GetV1QuotationIdResponses> => {
  return await _getV1QuotationId(baseUrl, request)
}
const _putV1QuotationId = async (url: string, request: Types.PutV1QuotationIdRequest): Promise<Types.PutV1QuotationIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1QuotationId: Api['putV1QuotationId'] = async (request: Types.PutV1QuotationIdRequest): Promise<Types.PutV1QuotationIdResponses> => {
  return await _putV1QuotationId(baseUrl, request)
}
const _deleteV1QuotationId = async (url: string, request: Types.DeleteV1QuotationIdRequest): Promise<Types.DeleteV1QuotationIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1QuotationId: Api['deleteV1QuotationId'] = async (request: Types.DeleteV1QuotationIdRequest): Promise<Types.DeleteV1QuotationIdResponses> => {
  return await _deleteV1QuotationId(baseUrl, request)
}
const _postV1QuotationSaveAsDraft = async (url: string, request: Types.PostV1QuotationSaveAsDraftRequest): Promise<Types.PostV1QuotationSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1QuotationSaveAsDraft: Api['postV1QuotationSaveAsDraft'] = async (request: Types.PostV1QuotationSaveAsDraftRequest): Promise<Types.PostV1QuotationSaveAsDraftResponses> => {
  return await _postV1QuotationSaveAsDraft(baseUrl, request)
}
const _patchV1QuotationStatusId = async (url: string, request: Types.PatchV1QuotationStatusIdRequest): Promise<Types.PatchV1QuotationStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1QuotationStatusId: Api['patchV1QuotationStatusId'] = async (request: Types.PatchV1QuotationStatusIdRequest): Promise<Types.PatchV1QuotationStatusIdResponses> => {
  return await _patchV1QuotationStatusId(baseUrl, request)
}
const _postV1QuotationPromotionCheck = async (url: string, request: Types.PostV1QuotationPromotionCheckRequest): Promise<Types.PostV1QuotationPromotionCheckResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/promotion/check`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1QuotationPromotionCheck: Api['postV1QuotationPromotionCheck'] = async (request: Types.PostV1QuotationPromotionCheckRequest): Promise<Types.PostV1QuotationPromotionCheckResponses> => {
  return await _postV1QuotationPromotionCheck(baseUrl, request)
}
const _postV1QuotationPromotionApply = async (url: string, request: Types.PostV1QuotationPromotionApplyRequest): Promise<Types.PostV1QuotationPromotionApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/promotion/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1QuotationPromotionApply: Api['postV1QuotationPromotionApply'] = async (request: Types.PostV1QuotationPromotionApplyRequest): Promise<Types.PostV1QuotationPromotionApplyResponses> => {
  return await _postV1QuotationPromotionApply(baseUrl, request)
}
const _postV1QuotationPromotionCouponApply = async (url: string, request: Types.PostV1QuotationPromotionCouponApplyRequest): Promise<Types.PostV1QuotationPromotionCouponApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/promotion/coupon/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1QuotationPromotionCouponApply: Api['postV1QuotationPromotionCouponApply'] = async (request: Types.PostV1QuotationPromotionCouponApplyRequest): Promise<Types.PostV1QuotationPromotionCouponApplyResponses> => {
  return await _postV1QuotationPromotionCouponApply(baseUrl, request)
}
const _postV1QuotationPromotionItemApply = async (url: string, request: Types.PostV1QuotationPromotionItemApplyRequest): Promise<Types.PostV1QuotationPromotionItemApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/promotion/item/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1QuotationPromotionItemApply: Api['postV1QuotationPromotionItemApply'] = async (request: Types.PostV1QuotationPromotionItemApplyRequest): Promise<Types.PostV1QuotationPromotionItemApplyResponses> => {
  return await _postV1QuotationPromotionItemApply(baseUrl, request)
}
const _deleteV1QuotationPromotionId = async (url: string, request: Types.DeleteV1QuotationPromotionIdRequest): Promise<Types.DeleteV1QuotationPromotionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/promotion/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1QuotationPromotionId: Api['deleteV1QuotationPromotionId'] = async (request: Types.DeleteV1QuotationPromotionIdRequest): Promise<Types.DeleteV1QuotationPromotionIdResponses> => {
  return await _deleteV1QuotationPromotionId(baseUrl, request)
}
const _postV1QuotationItem = async (url: string, request: Types.PostV1QuotationItemRequest): Promise<Types.PostV1QuotationItemResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/item/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1QuotationItem: Api['postV1QuotationItem'] = async (request: Types.PostV1QuotationItemRequest): Promise<Types.PostV1QuotationItemResponses> => {
  return await _postV1QuotationItem(baseUrl, request)
}
const _getV1QuotationItem = async (url: string, request: Types.GetV1QuotationItemRequest): Promise<Types.GetV1QuotationItemResponses> => {
  const queryParameters: (keyof Types.GetV1QuotationItemRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/item/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1QuotationItem: Api['getV1QuotationItem'] = async (request: Types.GetV1QuotationItemRequest): Promise<Types.GetV1QuotationItemResponses> => {
  return await _getV1QuotationItem(baseUrl, request)
}
const _getV1QuotationItemId = async (url: string, request: Types.GetV1QuotationItemIdRequest): Promise<Types.GetV1QuotationItemIdResponses> => {
  const queryParameters: (keyof Types.GetV1QuotationItemIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/item/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1QuotationItemId: Api['getV1QuotationItemId'] = async (request: Types.GetV1QuotationItemIdRequest): Promise<Types.GetV1QuotationItemIdResponses> => {
  return await _getV1QuotationItemId(baseUrl, request)
}
const _deleteV1QuotationItemId = async (url: string, request: Types.DeleteV1QuotationItemIdRequest): Promise<Types.DeleteV1QuotationItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/item/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1QuotationItemId: Api['deleteV1QuotationItemId'] = async (request: Types.DeleteV1QuotationItemIdRequest): Promise<Types.DeleteV1QuotationItemIdResponses> => {
  return await _deleteV1QuotationItemId(baseUrl, request)
}
const _putV1QuotationItemId = async (url: string, request: Types.PutV1QuotationItemIdRequest): Promise<Types.PutV1QuotationItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/item/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1QuotationItemId: Api['putV1QuotationItemId'] = async (request: Types.PutV1QuotationItemIdRequest): Promise<Types.PutV1QuotationItemIdResponses> => {
  return await _putV1QuotationItemId(baseUrl, request)
}
const _getV1QuotationIdPromotions = async (url: string, request: Types.GetV1QuotationIdPromotionsRequest): Promise<Types.GetV1QuotationIdPromotionsResponses> => {
  const queryParameters: (keyof Types.GetV1QuotationIdPromotionsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/${request['id']}/promotions?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1QuotationIdPromotions: Api['getV1QuotationIdPromotions'] = async (request: Types.GetV1QuotationIdPromotionsRequest): Promise<Types.GetV1QuotationIdPromotionsResponses> => {
  return await _getV1QuotationIdPromotions(baseUrl, request)
}
const _getV1QuotationIdDownload = async (url: string, request: Types.GetV1QuotationIdDownloadRequest): Promise<Types.GetV1QuotationIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1QuotationIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1QuotationIdDownload: Api['getV1QuotationIdDownload'] = async (request: Types.GetV1QuotationIdDownloadRequest): Promise<Types.GetV1QuotationIdDownloadResponses> => {
  return await _getV1QuotationIdDownload(baseUrl, request)
}
const _getV1QuotationIdSendEmail = async (url: string, request: Types.GetV1QuotationIdSendEmailRequest): Promise<Types.GetV1QuotationIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1QuotationIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1QuotationIdSendEmail: Api['getV1QuotationIdSendEmail'] = async (request: Types.GetV1QuotationIdSendEmailRequest): Promise<Types.GetV1QuotationIdSendEmailResponses> => {
  return await _getV1QuotationIdSendEmail(baseUrl, request)
}
const _getV1QuotationGenerateExcel = async (url: string, request: Types.GetV1QuotationGenerateExcelRequest): Promise<Types.GetV1QuotationGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1QuotationGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1QuotationGenerateExcel: Api['getV1QuotationGenerateExcel'] = async (request: Types.GetV1QuotationGenerateExcelRequest): Promise<Types.GetV1QuotationGenerateExcelResponses> => {
  return await _getV1QuotationGenerateExcel(baseUrl, request)
}
const _postV1QuotationImport = async (url: string, request: Types.PostV1QuotationImportRequest): Promise<Types.PostV1QuotationImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1QuotationImport: Api['postV1QuotationImport'] = async (request: Types.PostV1QuotationImportRequest): Promise<Types.PostV1QuotationImportResponses> => {
  return await _postV1QuotationImport(baseUrl, request)
}
const _getV1QuotationOpportunityId = async (url: string, request: Types.GetV1QuotationOpportunityIdRequest): Promise<Types.GetV1QuotationOpportunityIdResponses> => {
  const queryParameters: (keyof Types.GetV1QuotationOpportunityIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/opportunity/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1QuotationOpportunityId: Api['getV1QuotationOpportunityId'] = async (request: Types.GetV1QuotationOpportunityIdRequest): Promise<Types.GetV1QuotationOpportunityIdResponses> => {
  return await _getV1QuotationOpportunityId(baseUrl, request)
}
const _getV1QuotationFetchItemsPartyId = async (url: string, request: Types.GetV1QuotationFetchItemsPartyIdRequest): Promise<Types.GetV1QuotationFetchItemsPartyIdResponses> => {
  const queryParameters: (keyof Types.GetV1QuotationFetchItemsPartyIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/fetch-items/${request['partyId']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1QuotationFetchItemsPartyId: Api['getV1QuotationFetchItemsPartyId'] = async (request: Types.GetV1QuotationFetchItemsPartyIdRequest): Promise<Types.GetV1QuotationFetchItemsPartyIdResponses> => {
  return await _getV1QuotationFetchItemsPartyId(baseUrl, request)
}
const _getV1QuotationGeneratePdf = async (url: string, request: Types.GetV1QuotationGeneratePdfRequest): Promise<Types.GetV1QuotationGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1QuotationGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/quotation/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1QuotationGeneratePdf: Api['getV1QuotationGeneratePdf'] = async (request: Types.GetV1QuotationGeneratePdfRequest): Promise<Types.GetV1QuotationGeneratePdfResponses> => {
  return await _getV1QuotationGeneratePdf(baseUrl, request)
}
const _postV1SalesOrders = async (url: string, request: Types.PostV1SalesOrdersRequest): Promise<Types.PostV1SalesOrdersResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesOrders: Api['postV1SalesOrders'] = async (request: Types.PostV1SalesOrdersRequest): Promise<Types.PostV1SalesOrdersResponses> => {
  return await _postV1SalesOrders(baseUrl, request)
}
const _getV1SalesOrders = async (url: string, request: Types.GetV1SalesOrdersRequest): Promise<Types.GetV1SalesOrdersResponses> => {
  const queryParameters: (keyof Types.GetV1SalesOrdersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesOrders: Api['getV1SalesOrders'] = async (request: Types.GetV1SalesOrdersRequest): Promise<Types.GetV1SalesOrdersResponses> => {
  return await _getV1SalesOrders(baseUrl, request)
}
const _postV1SalesOrdersSaveDraft = async (url: string, request: Types.PostV1SalesOrdersSaveDraftRequest): Promise<Types.PostV1SalesOrdersSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesOrdersSaveDraft: Api['postV1SalesOrdersSaveDraft'] = async (request: Types.PostV1SalesOrdersSaveDraftRequest): Promise<Types.PostV1SalesOrdersSaveDraftResponses> => {
  return await _postV1SalesOrdersSaveDraft(baseUrl, request)
}
const _getV1SalesOrdersId = async (url: string, request: Types.GetV1SalesOrdersIdRequest): Promise<Types.GetV1SalesOrdersIdResponses> => {
  const queryParameters: (keyof Types.GetV1SalesOrdersIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesOrdersId: Api['getV1SalesOrdersId'] = async (request: Types.GetV1SalesOrdersIdRequest): Promise<Types.GetV1SalesOrdersIdResponses> => {
  return await _getV1SalesOrdersId(baseUrl, request)
}
const _putV1SalesOrdersId = async (url: string, request: Types.PutV1SalesOrdersIdRequest): Promise<Types.PutV1SalesOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1SalesOrdersId: Api['putV1SalesOrdersId'] = async (request: Types.PutV1SalesOrdersIdRequest): Promise<Types.PutV1SalesOrdersIdResponses> => {
  return await _putV1SalesOrdersId(baseUrl, request)
}
const _deleteV1SalesOrdersId = async (url: string, request: Types.DeleteV1SalesOrdersIdRequest): Promise<Types.DeleteV1SalesOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1SalesOrdersId: Api['deleteV1SalesOrdersId'] = async (request: Types.DeleteV1SalesOrdersIdRequest): Promise<Types.DeleteV1SalesOrdersIdResponses> => {
  return await _deleteV1SalesOrdersId(baseUrl, request)
}
const _patchV1SalesOrdersStatusId = async (url: string, request: Types.PatchV1SalesOrdersStatusIdRequest): Promise<Types.PatchV1SalesOrdersStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1SalesOrdersStatusId: Api['patchV1SalesOrdersStatusId'] = async (request: Types.PatchV1SalesOrdersStatusIdRequest): Promise<Types.PatchV1SalesOrdersStatusIdResponses> => {
  return await _patchV1SalesOrdersStatusId(baseUrl, request)
}
const _postV1SalesOrdersAddApprover = async (url: string, request: Types.PostV1SalesOrdersAddApproverRequest): Promise<Types.PostV1SalesOrdersAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesOrdersAddApprover: Api['postV1SalesOrdersAddApprover'] = async (request: Types.PostV1SalesOrdersAddApproverRequest): Promise<Types.PostV1SalesOrdersAddApproverResponses> => {
  return await _postV1SalesOrdersAddApprover(baseUrl, request)
}
const _putV1SalesOrdersApprovalStatusId = async (url: string, request: Types.PutV1SalesOrdersApprovalStatusIdRequest): Promise<Types.PutV1SalesOrdersApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1SalesOrdersApprovalStatusId: Api['putV1SalesOrdersApprovalStatusId'] = async (request: Types.PutV1SalesOrdersApprovalStatusIdRequest): Promise<Types.PutV1SalesOrdersApprovalStatusIdResponses> => {
  return await _putV1SalesOrdersApprovalStatusId(baseUrl, request)
}
const _postV1SalesOrdersItems = async (url: string, request: Types.PostV1SalesOrdersItemsRequest): Promise<Types.PostV1SalesOrdersItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesOrdersItems: Api['postV1SalesOrdersItems'] = async (request: Types.PostV1SalesOrdersItemsRequest): Promise<Types.PostV1SalesOrdersItemsResponses> => {
  return await _postV1SalesOrdersItems(baseUrl, request)
}
const _getV1SalesOrdersItemsId = async (url: string, request: Types.GetV1SalesOrdersItemsIdRequest): Promise<Types.GetV1SalesOrdersItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1SalesOrdersItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesOrdersItemsId: Api['getV1SalesOrdersItemsId'] = async (request: Types.GetV1SalesOrdersItemsIdRequest): Promise<Types.GetV1SalesOrdersItemsIdResponses> => {
  return await _getV1SalesOrdersItemsId(baseUrl, request)
}
const _putV1SalesOrdersItemsId = async (url: string, request: Types.PutV1SalesOrdersItemsIdRequest): Promise<Types.PutV1SalesOrdersItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1SalesOrdersItemsId: Api['putV1SalesOrdersItemsId'] = async (request: Types.PutV1SalesOrdersItemsIdRequest): Promise<Types.PutV1SalesOrdersItemsIdResponses> => {
  return await _putV1SalesOrdersItemsId(baseUrl, request)
}
const _deleteV1SalesOrdersItemsId = async (url: string, request: Types.DeleteV1SalesOrdersItemsIdRequest): Promise<Types.DeleteV1SalesOrdersItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1SalesOrdersItemsId: Api['deleteV1SalesOrdersItemsId'] = async (request: Types.DeleteV1SalesOrdersItemsIdRequest): Promise<Types.DeleteV1SalesOrdersItemsIdResponses> => {
  return await _deleteV1SalesOrdersItemsId(baseUrl, request)
}
const _postV1SalesOrdersPromotionCheck = async (url: string, request: Types.PostV1SalesOrdersPromotionCheckRequest): Promise<Types.PostV1SalesOrdersPromotionCheckResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/promotion/check`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesOrdersPromotionCheck: Api['postV1SalesOrdersPromotionCheck'] = async (request: Types.PostV1SalesOrdersPromotionCheckRequest): Promise<Types.PostV1SalesOrdersPromotionCheckResponses> => {
  return await _postV1SalesOrdersPromotionCheck(baseUrl, request)
}
const _postV1SalesOrdersPromotionApply = async (url: string, request: Types.PostV1SalesOrdersPromotionApplyRequest): Promise<Types.PostV1SalesOrdersPromotionApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/promotion/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesOrdersPromotionApply: Api['postV1SalesOrdersPromotionApply'] = async (request: Types.PostV1SalesOrdersPromotionApplyRequest): Promise<Types.PostV1SalesOrdersPromotionApplyResponses> => {
  return await _postV1SalesOrdersPromotionApply(baseUrl, request)
}
const _postV1SalesOrdersPromotionItemApply = async (url: string, request: Types.PostV1SalesOrdersPromotionItemApplyRequest): Promise<Types.PostV1SalesOrdersPromotionItemApplyResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/promotion/item/apply`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesOrdersPromotionItemApply: Api['postV1SalesOrdersPromotionItemApply'] = async (request: Types.PostV1SalesOrdersPromotionItemApplyRequest): Promise<Types.PostV1SalesOrdersPromotionItemApplyResponses> => {
  return await _postV1SalesOrdersPromotionItemApply(baseUrl, request)
}
const _deleteV1SalesOrdersPromotionId = async (url: string, request: Types.DeleteV1SalesOrdersPromotionIdRequest): Promise<Types.DeleteV1SalesOrdersPromotionIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/promotion/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1SalesOrdersPromotionId: Api['deleteV1SalesOrdersPromotionId'] = async (request: Types.DeleteV1SalesOrdersPromotionIdRequest): Promise<Types.DeleteV1SalesOrdersPromotionIdResponses> => {
  return await _deleteV1SalesOrdersPromotionId(baseUrl, request)
}
const _getV1SalesOrdersIdCreateInvoice = async (url: string, request: Types.GetV1SalesOrdersIdCreateInvoiceRequest): Promise<Types.GetV1SalesOrdersIdCreateInvoiceResponses> => {
  const queryParameters: (keyof Types.GetV1SalesOrdersIdCreateInvoiceRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/${request['id']}/create-invoice?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesOrdersIdCreateInvoice: Api['getV1SalesOrdersIdCreateInvoice'] = async (request: Types.GetV1SalesOrdersIdCreateInvoiceRequest): Promise<Types.GetV1SalesOrdersIdCreateInvoiceResponses> => {
  return await _getV1SalesOrdersIdCreateInvoice(baseUrl, request)
}
const _getV1SalesOrdersIdPromotions = async (url: string, request: Types.GetV1SalesOrdersIdPromotionsRequest): Promise<Types.GetV1SalesOrdersIdPromotionsResponses> => {
  const queryParameters: (keyof Types.GetV1SalesOrdersIdPromotionsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/${request['id']}/promotions?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesOrdersIdPromotions: Api['getV1SalesOrdersIdPromotions'] = async (request: Types.GetV1SalesOrdersIdPromotionsRequest): Promise<Types.GetV1SalesOrdersIdPromotionsResponses> => {
  return await _getV1SalesOrdersIdPromotions(baseUrl, request)
}
const _getV1SalesOrdersIdDownload = async (url: string, request: Types.GetV1SalesOrdersIdDownloadRequest): Promise<Types.GetV1SalesOrdersIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1SalesOrdersIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesOrdersIdDownload: Api['getV1SalesOrdersIdDownload'] = async (request: Types.GetV1SalesOrdersIdDownloadRequest): Promise<Types.GetV1SalesOrdersIdDownloadResponses> => {
  return await _getV1SalesOrdersIdDownload(baseUrl, request)
}
const _getV1SalesOrdersIdGeneratePickingList = async (url: string, request: Types.GetV1SalesOrdersIdGeneratePickingListRequest): Promise<Types.GetV1SalesOrdersIdGeneratePickingListResponses> => {
  const queryParameters: (keyof Types.GetV1SalesOrdersIdGeneratePickingListRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/${request['id']}/generate-picking-list?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesOrdersIdGeneratePickingList: Api['getV1SalesOrdersIdGeneratePickingList'] = async (request: Types.GetV1SalesOrdersIdGeneratePickingListRequest): Promise<Types.GetV1SalesOrdersIdGeneratePickingListResponses> => {
  return await _getV1SalesOrdersIdGeneratePickingList(baseUrl, request)
}
const _getV1SalesOrdersIdSendEmail = async (url: string, request: Types.GetV1SalesOrdersIdSendEmailRequest): Promise<Types.GetV1SalesOrdersIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1SalesOrdersIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesOrdersIdSendEmail: Api['getV1SalesOrdersIdSendEmail'] = async (request: Types.GetV1SalesOrdersIdSendEmailRequest): Promise<Types.GetV1SalesOrdersIdSendEmailResponses> => {
  return await _getV1SalesOrdersIdSendEmail(baseUrl, request)
}
const _getV1SalesOrdersTypeId = async (url: string, request: Types.GetV1SalesOrdersTypeIdRequest): Promise<Types.GetV1SalesOrdersTypeIdResponses> => {
  const queryParameters: (keyof Types.GetV1SalesOrdersTypeIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/${request['type']}/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesOrdersTypeId: Api['getV1SalesOrdersTypeId'] = async (request: Types.GetV1SalesOrdersTypeIdRequest): Promise<Types.GetV1SalesOrdersTypeIdResponses> => {
  return await _getV1SalesOrdersTypeId(baseUrl, request)
}
const _getV1SalesOrdersGenerateExcel = async (url: string, request: Types.GetV1SalesOrdersGenerateExcelRequest): Promise<Types.GetV1SalesOrdersGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1SalesOrdersGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesOrdersGenerateExcel: Api['getV1SalesOrdersGenerateExcel'] = async (request: Types.GetV1SalesOrdersGenerateExcelRequest): Promise<Types.GetV1SalesOrdersGenerateExcelResponses> => {
  return await _getV1SalesOrdersGenerateExcel(baseUrl, request)
}
const _postV1SalesOrdersImport = async (url: string, request: Types.PostV1SalesOrdersImportRequest): Promise<Types.PostV1SalesOrdersImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesOrdersImport: Api['postV1SalesOrdersImport'] = async (request: Types.PostV1SalesOrdersImportRequest): Promise<Types.PostV1SalesOrdersImportResponses> => {
  return await _postV1SalesOrdersImport(baseUrl, request)
}
const _getV1SalesOrdersInvoiceSchedulesIdProcess = async (url: string, request: Types.GetV1SalesOrdersInvoiceSchedulesIdProcessRequest): Promise<Types.GetV1SalesOrdersInvoiceSchedulesIdProcessResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/invoice-schedules/${request['id']}/process`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesOrdersInvoiceSchedulesIdProcess: Api['getV1SalesOrdersInvoiceSchedulesIdProcess'] = async (request: Types.GetV1SalesOrdersInvoiceSchedulesIdProcessRequest): Promise<Types.GetV1SalesOrdersInvoiceSchedulesIdProcessResponses> => {
  return await _getV1SalesOrdersInvoiceSchedulesIdProcess(baseUrl, request)
}
const _getV1SalesOrdersInvoiceSchedulesIdGetJob = async (url: string, request: Types.GetV1SalesOrdersInvoiceSchedulesIdGetJobRequest): Promise<Types.GetV1SalesOrdersInvoiceSchedulesIdGetJobResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/invoice-schedules/${request['id']}/get-job`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesOrdersInvoiceSchedulesIdGetJob: Api['getV1SalesOrdersInvoiceSchedulesIdGetJob'] = async (request: Types.GetV1SalesOrdersInvoiceSchedulesIdGetJobRequest): Promise<Types.GetV1SalesOrdersInvoiceSchedulesIdGetJobResponses> => {
  return await _getV1SalesOrdersInvoiceSchedulesIdGetJob(baseUrl, request)
}
const _postV1SalesOrdersInvoiceSchedulesScheduleIdProcess = async (url: string, request: Types.PostV1SalesOrdersInvoiceSchedulesScheduleIdProcessRequest): Promise<Types.PostV1SalesOrdersInvoiceSchedulesScheduleIdProcessResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }

  const response = await fetch(`${url}/v1/sales-orders/invoice-schedules/${request['scheduleId']}/process`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesOrdersInvoiceSchedulesScheduleIdProcess: Api['postV1SalesOrdersInvoiceSchedulesScheduleIdProcess'] = async (request: Types.PostV1SalesOrdersInvoiceSchedulesScheduleIdProcessRequest): Promise<Types.PostV1SalesOrdersInvoiceSchedulesScheduleIdProcessResponses> => {
  return await _postV1SalesOrdersInvoiceSchedulesScheduleIdProcess(baseUrl, request)
}
const _getV1SalesOrdersInvoiceJobsJobId = async (url: string, request: Types.GetV1SalesOrdersInvoiceJobsJobIdRequest): Promise<Types.GetV1SalesOrdersInvoiceJobsJobIdResponses> => {
  const headers = {
    ...defaultHeaders
  }

  const response = await fetch(`${url}/v1/sales-orders/invoice-jobs/${request['jobId']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesOrdersInvoiceJobsJobId: Api['getV1SalesOrdersInvoiceJobsJobId'] = async (request: Types.GetV1SalesOrdersInvoiceJobsJobIdRequest): Promise<Types.GetV1SalesOrdersInvoiceJobsJobIdResponses> => {
  return await _getV1SalesOrdersInvoiceJobsJobId(baseUrl, request)
}
const _getV1SalesOrdersGeneratePdf = async (url: string, request: Types.GetV1SalesOrdersGeneratePdfRequest): Promise<Types.GetV1SalesOrdersGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1SalesOrdersGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-orders/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesOrdersGeneratePdf: Api['getV1SalesOrdersGeneratePdf'] = async (request: Types.GetV1SalesOrdersGeneratePdfRequest): Promise<Types.GetV1SalesOrdersGeneratePdfResponses> => {
  return await _getV1SalesOrdersGeneratePdf(baseUrl, request)
}
const _postV1DeliveryOrders = async (url: string, request: Types.PostV1DeliveryOrdersRequest): Promise<Types.PostV1DeliveryOrdersResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DeliveryOrders: Api['postV1DeliveryOrders'] = async (request: Types.PostV1DeliveryOrdersRequest): Promise<Types.PostV1DeliveryOrdersResponses> => {
  return await _postV1DeliveryOrders(baseUrl, request)
}
const _getV1DeliveryOrders = async (url: string, request: Types.GetV1DeliveryOrdersRequest): Promise<Types.GetV1DeliveryOrdersResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrders: Api['getV1DeliveryOrders'] = async (request: Types.GetV1DeliveryOrdersRequest): Promise<Types.GetV1DeliveryOrdersResponses> => {
  return await _getV1DeliveryOrders(baseUrl, request)
}
const _postV1DeliveryOrdersSaveDraft = async (url: string, request: Types.PostV1DeliveryOrdersSaveDraftRequest): Promise<Types.PostV1DeliveryOrdersSaveDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/save-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DeliveryOrdersSaveDraft: Api['postV1DeliveryOrdersSaveDraft'] = async (request: Types.PostV1DeliveryOrdersSaveDraftRequest): Promise<Types.PostV1DeliveryOrdersSaveDraftResponses> => {
  return await _postV1DeliveryOrdersSaveDraft(baseUrl, request)
}
const _getV1DeliveryOrdersId = async (url: string, request: Types.GetV1DeliveryOrdersIdRequest): Promise<Types.GetV1DeliveryOrdersIdResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersId: Api['getV1DeliveryOrdersId'] = async (request: Types.GetV1DeliveryOrdersIdRequest): Promise<Types.GetV1DeliveryOrdersIdResponses> => {
  return await _getV1DeliveryOrdersId(baseUrl, request)
}
const _deleteV1DeliveryOrdersId = async (url: string, request: Types.DeleteV1DeliveryOrdersIdRequest): Promise<Types.DeleteV1DeliveryOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DeliveryOrdersId: Api['deleteV1DeliveryOrdersId'] = async (request: Types.DeleteV1DeliveryOrdersIdRequest): Promise<Types.DeleteV1DeliveryOrdersIdResponses> => {
  return await _deleteV1DeliveryOrdersId(baseUrl, request)
}
const _putV1DeliveryOrdersId = async (url: string, request: Types.PutV1DeliveryOrdersIdRequest): Promise<Types.PutV1DeliveryOrdersIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DeliveryOrdersId: Api['putV1DeliveryOrdersId'] = async (request: Types.PutV1DeliveryOrdersIdRequest): Promise<Types.PutV1DeliveryOrdersIdResponses> => {
  return await _putV1DeliveryOrdersId(baseUrl, request)
}
const _patchV1DeliveryOrdersStatusId = async (url: string, request: Types.PatchV1DeliveryOrdersStatusIdRequest): Promise<Types.PatchV1DeliveryOrdersStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1DeliveryOrdersStatusId: Api['patchV1DeliveryOrdersStatusId'] = async (request: Types.PatchV1DeliveryOrdersStatusIdRequest): Promise<Types.PatchV1DeliveryOrdersStatusIdResponses> => {
  return await _patchV1DeliveryOrdersStatusId(baseUrl, request)
}
const _getV1DeliveryOrdersItemsId = async (url: string, request: Types.GetV1DeliveryOrdersItemsIdRequest): Promise<Types.GetV1DeliveryOrdersItemsIdResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersItemsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/items/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersItemsId: Api['getV1DeliveryOrdersItemsId'] = async (request: Types.GetV1DeliveryOrdersItemsIdRequest): Promise<Types.GetV1DeliveryOrdersItemsIdResponses> => {
  return await _getV1DeliveryOrdersItemsId(baseUrl, request)
}
const _putV1DeliveryOrdersItemsId = async (url: string, request: Types.PutV1DeliveryOrdersItemsIdRequest): Promise<Types.PutV1DeliveryOrdersItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DeliveryOrdersItemsId: Api['putV1DeliveryOrdersItemsId'] = async (request: Types.PutV1DeliveryOrdersItemsIdRequest): Promise<Types.PutV1DeliveryOrdersItemsIdResponses> => {
  return await _putV1DeliveryOrdersItemsId(baseUrl, request)
}
const _deleteV1DeliveryOrdersItemsId = async (url: string, request: Types.DeleteV1DeliveryOrdersItemsIdRequest): Promise<Types.DeleteV1DeliveryOrdersItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DeliveryOrdersItemsId: Api['deleteV1DeliveryOrdersItemsId'] = async (request: Types.DeleteV1DeliveryOrdersItemsIdRequest): Promise<Types.DeleteV1DeliveryOrdersItemsIdResponses> => {
  return await _deleteV1DeliveryOrdersItemsId(baseUrl, request)
}
const _postV1DeliveryOrdersPackages = async (url: string, request: Types.PostV1DeliveryOrdersPackagesRequest): Promise<Types.PostV1DeliveryOrdersPackagesResponses> => {
  const queryParameters: (keyof Types.PostV1DeliveryOrdersPackagesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/packages/?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DeliveryOrdersPackages: Api['postV1DeliveryOrdersPackages'] = async (request: Types.PostV1DeliveryOrdersPackagesRequest): Promise<Types.PostV1DeliveryOrdersPackagesResponses> => {
  return await _postV1DeliveryOrdersPackages(baseUrl, request)
}
const _getV1DeliveryOrdersPackagesId = async (url: string, request: Types.GetV1DeliveryOrdersPackagesIdRequest): Promise<Types.GetV1DeliveryOrdersPackagesIdResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersPackagesIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/packages/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersPackagesId: Api['getV1DeliveryOrdersPackagesId'] = async (request: Types.GetV1DeliveryOrdersPackagesIdRequest): Promise<Types.GetV1DeliveryOrdersPackagesIdResponses> => {
  return await _getV1DeliveryOrdersPackagesId(baseUrl, request)
}
const _putV1DeliveryOrdersPackagesId = async (url: string, request: Types.PutV1DeliveryOrdersPackagesIdRequest): Promise<Types.PutV1DeliveryOrdersPackagesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/packages/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1DeliveryOrdersPackagesId: Api['putV1DeliveryOrdersPackagesId'] = async (request: Types.PutV1DeliveryOrdersPackagesIdRequest): Promise<Types.PutV1DeliveryOrdersPackagesIdResponses> => {
  return await _putV1DeliveryOrdersPackagesId(baseUrl, request)
}
const _deleteV1DeliveryOrdersPackagesId = async (url: string, request: Types.DeleteV1DeliveryOrdersPackagesIdRequest): Promise<Types.DeleteV1DeliveryOrdersPackagesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/packages/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DeliveryOrdersPackagesId: Api['deleteV1DeliveryOrdersPackagesId'] = async (request: Types.DeleteV1DeliveryOrdersPackagesIdRequest): Promise<Types.DeleteV1DeliveryOrdersPackagesIdResponses> => {
  return await _deleteV1DeliveryOrdersPackagesId(baseUrl, request)
}
const _getV1DeliveryOrdersIdPackages = async (url: string, request: Types.GetV1DeliveryOrdersIdPackagesRequest): Promise<Types.GetV1DeliveryOrdersIdPackagesResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersIdPackagesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['id']}/packages/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersIdPackages: Api['getV1DeliveryOrdersIdPackages'] = async (request: Types.GetV1DeliveryOrdersIdPackagesRequest): Promise<Types.GetV1DeliveryOrdersIdPackagesResponses> => {
  return await _getV1DeliveryOrdersIdPackages(baseUrl, request)
}
const _postV1DeliveryOrdersDeliveryIdItemsItemIdPackages = async (url: string, request: Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdPackagesRequest): Promise<Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdPackagesResponses> => {
  const queryParameters: (keyof Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdPackagesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['deliveryId']}/items/${request['itemId']}/packages/?${searchParams.toString()}`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DeliveryOrdersDeliveryIdItemsItemIdPackages: Api['postV1DeliveryOrdersDeliveryIdItemsItemIdPackages'] = async (request: Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdPackagesRequest): Promise<Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdPackagesResponses> => {
  return await _postV1DeliveryOrdersDeliveryIdItemsItemIdPackages(baseUrl, request)
}
const _getV1DeliveryOrdersDeliveryIdItemsItemIdPackages = async (url: string, request: Types.GetV1DeliveryOrdersDeliveryIdItemsItemIdPackagesRequest): Promise<Types.GetV1DeliveryOrdersDeliveryIdItemsItemIdPackagesResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['deliveryId']}/items/${request['itemId']}/packages/`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersDeliveryIdItemsItemIdPackages: Api['getV1DeliveryOrdersDeliveryIdItemsItemIdPackages'] = async (request: Types.GetV1DeliveryOrdersDeliveryIdItemsItemIdPackagesRequest): Promise<Types.GetV1DeliveryOrdersDeliveryIdItemsItemIdPackagesResponses> => {
  return await _getV1DeliveryOrdersDeliveryIdItemsItemIdPackages(baseUrl, request)
}
const _deleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesId = async (url: string, request: Types.DeleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesIdRequest): Promise<Types.DeleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['deliveryId']}/items/${request['itemId']}/packages/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesId: Api['deleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesId'] = async (request: Types.DeleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesIdRequest): Promise<Types.DeleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesIdResponses> => {
  return await _deleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesId(baseUrl, request)
}
const _postV1DeliveryOrdersDeliveryIdItemsItemIdTracking = async (url: string, request: Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdTrackingRequest): Promise<Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdTrackingResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['deliveryId']}/items/${request['itemId']}/tracking`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DeliveryOrdersDeliveryIdItemsItemIdTracking: Api['postV1DeliveryOrdersDeliveryIdItemsItemIdTracking'] = async (request: Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdTrackingRequest): Promise<Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdTrackingResponses> => {
  return await _postV1DeliveryOrdersDeliveryIdItemsItemIdTracking(baseUrl, request)
}
const _postV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustment = async (url: string, request: Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustmentRequest): Promise<Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustmentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['deliveryId']}/items/${request['itemId']}/inventory-adjustment`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustment: Api['postV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustment'] = async (request: Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustmentRequest): Promise<Types.PostV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustmentResponses> => {
  return await _postV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustment(baseUrl, request)
}
const _getV1DeliveryOrdersIdCreateInvoice = async (url: string, request: Types.GetV1DeliveryOrdersIdCreateInvoiceRequest): Promise<Types.GetV1DeliveryOrdersIdCreateInvoiceResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersIdCreateInvoiceRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['id']}/create-invoice?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersIdCreateInvoice: Api['getV1DeliveryOrdersIdCreateInvoice'] = async (request: Types.GetV1DeliveryOrdersIdCreateInvoiceRequest): Promise<Types.GetV1DeliveryOrdersIdCreateInvoiceResponses> => {
  return await _getV1DeliveryOrdersIdCreateInvoice(baseUrl, request)
}
const _getV1DeliveryOrdersIdSendEmail = async (url: string, request: Types.GetV1DeliveryOrdersIdSendEmailRequest): Promise<Types.GetV1DeliveryOrdersIdSendEmailResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersIdSendEmailRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['id']}/send-email?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersIdSendEmail: Api['getV1DeliveryOrdersIdSendEmail'] = async (request: Types.GetV1DeliveryOrdersIdSendEmailRequest): Promise<Types.GetV1DeliveryOrdersIdSendEmailResponses> => {
  return await _getV1DeliveryOrdersIdSendEmail(baseUrl, request)
}
const _getV1DeliveryOrdersIdDownload = async (url: string, request: Types.GetV1DeliveryOrdersIdDownloadRequest): Promise<Types.GetV1DeliveryOrdersIdDownloadResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersIdDownloadRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['id']}/download?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersIdDownload: Api['getV1DeliveryOrdersIdDownload'] = async (request: Types.GetV1DeliveryOrdersIdDownloadRequest): Promise<Types.GetV1DeliveryOrdersIdDownloadResponses> => {
  return await _getV1DeliveryOrdersIdDownload(baseUrl, request)
}
const _getV1DeliveryOrdersGenerateExcel = async (url: string, request: Types.GetV1DeliveryOrdersGenerateExcelRequest): Promise<Types.GetV1DeliveryOrdersGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersGenerateExcel: Api['getV1DeliveryOrdersGenerateExcel'] = async (request: Types.GetV1DeliveryOrdersGenerateExcelRequest): Promise<Types.GetV1DeliveryOrdersGenerateExcelResponses> => {
  return await _getV1DeliveryOrdersGenerateExcel(baseUrl, request)
}
const _getV1DeliveryOrdersSalesOrderId = async (url: string, request: Types.GetV1DeliveryOrdersSalesOrderIdRequest): Promise<Types.GetV1DeliveryOrdersSalesOrderIdResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersSalesOrderIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/sales-order/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersSalesOrderId: Api['getV1DeliveryOrdersSalesOrderId'] = async (request: Types.GetV1DeliveryOrdersSalesOrderIdRequest): Promise<Types.GetV1DeliveryOrdersSalesOrderIdResponses> => {
  return await _getV1DeliveryOrdersSalesOrderId(baseUrl, request)
}
const _deleteV1DeliveryOrdersDeliveryIdPackageItemsId = async (url: string, request: Types.DeleteV1DeliveryOrdersDeliveryIdPackageItemsIdRequest): Promise<Types.DeleteV1DeliveryOrdersDeliveryIdPackageItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/${request['deliveryId']}/package-items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1DeliveryOrdersDeliveryIdPackageItemsId: Api['deleteV1DeliveryOrdersDeliveryIdPackageItemsId'] = async (request: Types.DeleteV1DeliveryOrdersDeliveryIdPackageItemsIdRequest): Promise<Types.DeleteV1DeliveryOrdersDeliveryIdPackageItemsIdResponses> => {
  return await _deleteV1DeliveryOrdersDeliveryIdPackageItemsId(baseUrl, request)
}
const _getV1DeliveryOrdersGeneratePdf = async (url: string, request: Types.GetV1DeliveryOrdersGeneratePdfRequest): Promise<Types.GetV1DeliveryOrdersGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1DeliveryOrdersGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/delivery-orders/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1DeliveryOrdersGeneratePdf: Api['getV1DeliveryOrdersGeneratePdf'] = async (request: Types.GetV1DeliveryOrdersGeneratePdfRequest): Promise<Types.GetV1DeliveryOrdersGeneratePdfResponses> => {
  return await _getV1DeliveryOrdersGeneratePdf(baseUrl, request)
}
const _getV1CustomerReturns = async (url: string, request: Types.GetV1CustomerReturnsRequest): Promise<Types.GetV1CustomerReturnsResponses> => {
  const queryParameters: (keyof Types.GetV1CustomerReturnsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CustomerReturns: Api['getV1CustomerReturns'] = async (request: Types.GetV1CustomerReturnsRequest): Promise<Types.GetV1CustomerReturnsResponses> => {
  return await _getV1CustomerReturns(baseUrl, request)
}
const _postV1CustomerReturns = async (url: string, request: Types.PostV1CustomerReturnsRequest): Promise<Types.PostV1CustomerReturnsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CustomerReturns: Api['postV1CustomerReturns'] = async (request: Types.PostV1CustomerReturnsRequest): Promise<Types.PostV1CustomerReturnsResponses> => {
  return await _postV1CustomerReturns(baseUrl, request)
}
const _postV1CustomerReturnsSaveAsDraft = async (url: string, request: Types.PostV1CustomerReturnsSaveAsDraftRequest): Promise<Types.PostV1CustomerReturnsSaveAsDraftResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/save-as-draft`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CustomerReturnsSaveAsDraft: Api['postV1CustomerReturnsSaveAsDraft'] = async (request: Types.PostV1CustomerReturnsSaveAsDraftRequest): Promise<Types.PostV1CustomerReturnsSaveAsDraftResponses> => {
  return await _postV1CustomerReturnsSaveAsDraft(baseUrl, request)
}
const _getV1CustomerReturnsId = async (url: string, request: Types.GetV1CustomerReturnsIdRequest): Promise<Types.GetV1CustomerReturnsIdResponses> => {
  const queryParameters: (keyof Types.GetV1CustomerReturnsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CustomerReturnsId: Api['getV1CustomerReturnsId'] = async (request: Types.GetV1CustomerReturnsIdRequest): Promise<Types.GetV1CustomerReturnsIdResponses> => {
  return await _getV1CustomerReturnsId(baseUrl, request)
}
const _putV1CustomerReturnsId = async (url: string, request: Types.PutV1CustomerReturnsIdRequest): Promise<Types.PutV1CustomerReturnsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CustomerReturnsId: Api['putV1CustomerReturnsId'] = async (request: Types.PutV1CustomerReturnsIdRequest): Promise<Types.PutV1CustomerReturnsIdResponses> => {
  return await _putV1CustomerReturnsId(baseUrl, request)
}
const _deleteV1CustomerReturnsId = async (url: string, request: Types.DeleteV1CustomerReturnsIdRequest): Promise<Types.DeleteV1CustomerReturnsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CustomerReturnsId: Api['deleteV1CustomerReturnsId'] = async (request: Types.DeleteV1CustomerReturnsIdRequest): Promise<Types.DeleteV1CustomerReturnsIdResponses> => {
  return await _deleteV1CustomerReturnsId(baseUrl, request)
}
const _getV1CustomerReturnsCreditNoteRmaId = async (url: string, request: Types.GetV1CustomerReturnsCreditNoteRmaIdRequest): Promise<Types.GetV1CustomerReturnsCreditNoteRmaIdResponses> => {
  const queryParameters: (keyof Types.GetV1CustomerReturnsCreditNoteRmaIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/credit-note/rma/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CustomerReturnsCreditNoteRmaId: Api['getV1CustomerReturnsCreditNoteRmaId'] = async (request: Types.GetV1CustomerReturnsCreditNoteRmaIdRequest): Promise<Types.GetV1CustomerReturnsCreditNoteRmaIdResponses> => {
  return await _getV1CustomerReturnsCreditNoteRmaId(baseUrl, request)
}
const _patchV1CustomerReturnsStatusId = async (url: string, request: Types.PatchV1CustomerReturnsStatusIdRequest): Promise<Types.PatchV1CustomerReturnsStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1CustomerReturnsStatusId: Api['patchV1CustomerReturnsStatusId'] = async (request: Types.PatchV1CustomerReturnsStatusIdRequest): Promise<Types.PatchV1CustomerReturnsStatusIdResponses> => {
  return await _patchV1CustomerReturnsStatusId(baseUrl, request)
}
const _postV1CustomerReturnsItems = async (url: string, request: Types.PostV1CustomerReturnsItemsRequest): Promise<Types.PostV1CustomerReturnsItemsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/items/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CustomerReturnsItems: Api['postV1CustomerReturnsItems'] = async (request: Types.PostV1CustomerReturnsItemsRequest): Promise<Types.PostV1CustomerReturnsItemsResponses> => {
  return await _postV1CustomerReturnsItems(baseUrl, request)
}
const _putV1CustomerReturnsItemsId = async (url: string, request: Types.PutV1CustomerReturnsItemsIdRequest): Promise<Types.PutV1CustomerReturnsItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/items/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CustomerReturnsItemsId: Api['putV1CustomerReturnsItemsId'] = async (request: Types.PutV1CustomerReturnsItemsIdRequest): Promise<Types.PutV1CustomerReturnsItemsIdResponses> => {
  return await _putV1CustomerReturnsItemsId(baseUrl, request)
}
const _deleteV1CustomerReturnsItemsId = async (url: string, request: Types.DeleteV1CustomerReturnsItemsIdRequest): Promise<Types.DeleteV1CustomerReturnsItemsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/items/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CustomerReturnsItemsId: Api['deleteV1CustomerReturnsItemsId'] = async (request: Types.DeleteV1CustomerReturnsItemsIdRequest): Promise<Types.DeleteV1CustomerReturnsItemsIdResponses> => {
  return await _deleteV1CustomerReturnsItemsId(baseUrl, request)
}
const _postV1CustomerReturnsAddApprover = async (url: string, request: Types.PostV1CustomerReturnsAddApproverRequest): Promise<Types.PostV1CustomerReturnsAddApproverResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/add-approver`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CustomerReturnsAddApprover: Api['postV1CustomerReturnsAddApprover'] = async (request: Types.PostV1CustomerReturnsAddApproverRequest): Promise<Types.PostV1CustomerReturnsAddApproverResponses> => {
  return await _postV1CustomerReturnsAddApprover(baseUrl, request)
}
const _putV1CustomerReturnsApprovalStatusId = async (url: string, request: Types.PutV1CustomerReturnsApprovalStatusIdRequest): Promise<Types.PutV1CustomerReturnsApprovalStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/approval-status/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CustomerReturnsApprovalStatusId: Api['putV1CustomerReturnsApprovalStatusId'] = async (request: Types.PutV1CustomerReturnsApprovalStatusIdRequest): Promise<Types.PutV1CustomerReturnsApprovalStatusIdResponses> => {
  return await _putV1CustomerReturnsApprovalStatusId(baseUrl, request)
}
const _postV1CustomerReturnsRmaIdGrn = async (url: string, request: Types.PostV1CustomerReturnsRmaIdGrnRequest): Promise<Types.PostV1CustomerReturnsRmaIdGrnResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/${request['rmaId']}/grn`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CustomerReturnsRmaIdGrn: Api['postV1CustomerReturnsRmaIdGrn'] = async (request: Types.PostV1CustomerReturnsRmaIdGrnRequest): Promise<Types.PostV1CustomerReturnsRmaIdGrnResponses> => {
  return await _postV1CustomerReturnsRmaIdGrn(baseUrl, request)
}
const _getV1CustomerReturnsRmaIdGrn = async (url: string, request: Types.GetV1CustomerReturnsRmaIdGrnRequest): Promise<Types.GetV1CustomerReturnsRmaIdGrnResponses> => {
  const queryParameters: (keyof Types.GetV1CustomerReturnsRmaIdGrnRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/${request['rmaId']}/grn?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CustomerReturnsRmaIdGrn: Api['getV1CustomerReturnsRmaIdGrn'] = async (request: Types.GetV1CustomerReturnsRmaIdGrnRequest): Promise<Types.GetV1CustomerReturnsRmaIdGrnResponses> => {
  return await _getV1CustomerReturnsRmaIdGrn(baseUrl, request)
}
const _putV1CustomerReturnsRmaIdGrnId = async (url: string, request: Types.PutV1CustomerReturnsRmaIdGrnIdRequest): Promise<Types.PutV1CustomerReturnsRmaIdGrnIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/${request['rmaId']}/grn/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CustomerReturnsRmaIdGrnId: Api['putV1CustomerReturnsRmaIdGrnId'] = async (request: Types.PutV1CustomerReturnsRmaIdGrnIdRequest): Promise<Types.PutV1CustomerReturnsRmaIdGrnIdResponses> => {
  return await _putV1CustomerReturnsRmaIdGrnId(baseUrl, request)
}
const _deleteV1CustomerReturnsRmaIdGrnId = async (url: string, request: Types.DeleteV1CustomerReturnsRmaIdGrnIdRequest): Promise<Types.DeleteV1CustomerReturnsRmaIdGrnIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/${request['rmaId']}/grn/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CustomerReturnsRmaIdGrnId: Api['deleteV1CustomerReturnsRmaIdGrnId'] = async (request: Types.DeleteV1CustomerReturnsRmaIdGrnIdRequest): Promise<Types.DeleteV1CustomerReturnsRmaIdGrnIdResponses> => {
  return await _deleteV1CustomerReturnsRmaIdGrnId(baseUrl, request)
}
const _getV1CustomerReturnsRmaIdGrnId = async (url: string, request: Types.GetV1CustomerReturnsRmaIdGrnIdRequest): Promise<Types.GetV1CustomerReturnsRmaIdGrnIdResponses> => {
  const queryParameters: (keyof Types.GetV1CustomerReturnsRmaIdGrnIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/${request['rmaId']}/grn/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CustomerReturnsRmaIdGrnId: Api['getV1CustomerReturnsRmaIdGrnId'] = async (request: Types.GetV1CustomerReturnsRmaIdGrnIdRequest): Promise<Types.GetV1CustomerReturnsRmaIdGrnIdResponses> => {
  return await _getV1CustomerReturnsRmaIdGrnId(baseUrl, request)
}
const _getV1CustomerReturnsRmaIdGrnGrnIdItemId = async (url: string, request: Types.GetV1CustomerReturnsRmaIdGrnGrnIdItemIdRequest): Promise<Types.GetV1CustomerReturnsRmaIdGrnGrnIdItemIdResponses> => {
  const queryParameters: (keyof Types.GetV1CustomerReturnsRmaIdGrnGrnIdItemIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/${request['rmaId']}/grn/${request['grnId']}/item/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CustomerReturnsRmaIdGrnGrnIdItemId: Api['getV1CustomerReturnsRmaIdGrnGrnIdItemId'] = async (request: Types.GetV1CustomerReturnsRmaIdGrnGrnIdItemIdRequest): Promise<Types.GetV1CustomerReturnsRmaIdGrnGrnIdItemIdResponses> => {
  return await _getV1CustomerReturnsRmaIdGrnGrnIdItemId(baseUrl, request)
}
const _putV1CustomerReturnsRmaIdGrnGrnIdItemId = async (url: string, request: Types.PutV1CustomerReturnsRmaIdGrnGrnIdItemIdRequest): Promise<Types.PutV1CustomerReturnsRmaIdGrnGrnIdItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/${request['rmaId']}/grn/${request['grnId']}/item/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1CustomerReturnsRmaIdGrnGrnIdItemId: Api['putV1CustomerReturnsRmaIdGrnGrnIdItemId'] = async (request: Types.PutV1CustomerReturnsRmaIdGrnGrnIdItemIdRequest): Promise<Types.PutV1CustomerReturnsRmaIdGrnGrnIdItemIdResponses> => {
  return await _putV1CustomerReturnsRmaIdGrnGrnIdItemId(baseUrl, request)
}
const _deleteV1CustomerReturnsRmaIdGrnGrnIdItemId = async (url: string, request: Types.DeleteV1CustomerReturnsRmaIdGrnGrnIdItemIdRequest): Promise<Types.DeleteV1CustomerReturnsRmaIdGrnGrnIdItemIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/${request['rmaId']}/grn/${request['grnId']}/item/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1CustomerReturnsRmaIdGrnGrnIdItemId: Api['deleteV1CustomerReturnsRmaIdGrnGrnIdItemId'] = async (request: Types.DeleteV1CustomerReturnsRmaIdGrnGrnIdItemIdRequest): Promise<Types.DeleteV1CustomerReturnsRmaIdGrnGrnIdItemIdResponses> => {
  return await _deleteV1CustomerReturnsRmaIdGrnGrnIdItemId(baseUrl, request)
}
const _postV1CustomerReturnsRmaIdGrnGrnIdItemsItemIdTracking = async (url: string, request: Types.PostV1CustomerReturnsRmaIdGrnGrnIdItemsItemIdTrackingRequest): Promise<Types.PostV1CustomerReturnsRmaIdGrnGrnIdItemsItemIdTrackingResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/${request['rmaId']}/grn/${request['grnId']}/items/${request['itemId']}/tracking`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CustomerReturnsRmaIdGrnGrnIdItemsItemIdTracking: Api['postV1CustomerReturnsRmaIdGrnGrnIdItemsItemIdTracking'] = async (request: Types.PostV1CustomerReturnsRmaIdGrnGrnIdItemsItemIdTrackingRequest): Promise<Types.PostV1CustomerReturnsRmaIdGrnGrnIdItemsItemIdTrackingResponses> => {
  return await _postV1CustomerReturnsRmaIdGrnGrnIdItemsItemIdTracking(baseUrl, request)
}
const _postV1CustomerReturnsRmaIdGrnGrnIdInventoryAdjustment = async (url: string, request: Types.PostV1CustomerReturnsRmaIdGrnGrnIdInventoryAdjustmentRequest): Promise<Types.PostV1CustomerReturnsRmaIdGrnGrnIdInventoryAdjustmentResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/${request['rmaId']}/grn/${request['grnId']}/inventory-adjustment`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CustomerReturnsRmaIdGrnGrnIdInventoryAdjustment: Api['postV1CustomerReturnsRmaIdGrnGrnIdInventoryAdjustment'] = async (request: Types.PostV1CustomerReturnsRmaIdGrnGrnIdInventoryAdjustmentRequest): Promise<Types.PostV1CustomerReturnsRmaIdGrnGrnIdInventoryAdjustmentResponses> => {
  return await _postV1CustomerReturnsRmaIdGrnGrnIdInventoryAdjustment(baseUrl, request)
}
const _postV1CustomerReturnsRmaIdGrnGrnIdReturnSalesOrder = async (url: string, request: Types.PostV1CustomerReturnsRmaIdGrnGrnIdReturnSalesOrderRequest): Promise<Types.PostV1CustomerReturnsRmaIdGrnGrnIdReturnSalesOrderResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/${request['rmaId']}/grn/${request['grnId']}/return-sales-order`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CustomerReturnsRmaIdGrnGrnIdReturnSalesOrder: Api['postV1CustomerReturnsRmaIdGrnGrnIdReturnSalesOrder'] = async (request: Types.PostV1CustomerReturnsRmaIdGrnGrnIdReturnSalesOrderRequest): Promise<Types.PostV1CustomerReturnsRmaIdGrnGrnIdReturnSalesOrderResponses> => {
  return await _postV1CustomerReturnsRmaIdGrnGrnIdReturnSalesOrder(baseUrl, request)
}
const _getV1CustomerReturnsGenerateExcel = async (url: string, request: Types.GetV1CustomerReturnsGenerateExcelRequest): Promise<Types.GetV1CustomerReturnsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1CustomerReturnsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CustomerReturnsGenerateExcel: Api['getV1CustomerReturnsGenerateExcel'] = async (request: Types.GetV1CustomerReturnsGenerateExcelRequest): Promise<Types.GetV1CustomerReturnsGenerateExcelResponses> => {
  return await _getV1CustomerReturnsGenerateExcel(baseUrl, request)
}
const _postV1CustomerReturnsImport = async (url: string, request: Types.PostV1CustomerReturnsImportRequest): Promise<Types.PostV1CustomerReturnsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1CustomerReturnsImport: Api['postV1CustomerReturnsImport'] = async (request: Types.PostV1CustomerReturnsImportRequest): Promise<Types.PostV1CustomerReturnsImportResponses> => {
  return await _postV1CustomerReturnsImport(baseUrl, request)
}
const _getV1CustomerReturnsGeneratePdf = async (url: string, request: Types.GetV1CustomerReturnsGeneratePdfRequest): Promise<Types.GetV1CustomerReturnsGeneratePdfResponses> => {
  const queryParameters: (keyof Types.GetV1CustomerReturnsGeneratePdfRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/customer-returns/generate-pdf?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1CustomerReturnsGeneratePdf: Api['getV1CustomerReturnsGeneratePdf'] = async (request: Types.GetV1CustomerReturnsGeneratePdfRequest): Promise<Types.GetV1CustomerReturnsGeneratePdfResponses> => {
  return await _getV1CustomerReturnsGeneratePdf(baseUrl, request)
}
const _postV1ReportsSalesOrderSummary = async (url: string, request: Types.PostV1ReportsSalesOrderSummaryRequest): Promise<Types.PostV1ReportsSalesOrderSummaryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/sales-order-summary`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsSalesOrderSummary: Api['postV1ReportsSalesOrderSummary'] = async (request: Types.PostV1ReportsSalesOrderSummaryRequest): Promise<Types.PostV1ReportsSalesOrderSummaryResponses> => {
  return await _postV1ReportsSalesOrderSummary(baseUrl, request)
}
const _postV1ReportsSalesOrderDetail = async (url: string, request: Types.PostV1ReportsSalesOrderDetailRequest): Promise<Types.PostV1ReportsSalesOrderDetailResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/sales-order-detail`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsSalesOrderDetail: Api['postV1ReportsSalesOrderDetail'] = async (request: Types.PostV1ReportsSalesOrderDetailRequest): Promise<Types.PostV1ReportsSalesOrderDetailResponses> => {
  return await _postV1ReportsSalesOrderDetail(baseUrl, request)
}
const _postV1ReportsPendingQuotesApprovals = async (url: string, request: Types.PostV1ReportsPendingQuotesApprovalsRequest): Promise<Types.PostV1ReportsPendingQuotesApprovalsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/pending-quotes-approvals`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsPendingQuotesApprovals: Api['postV1ReportsPendingQuotesApprovals'] = async (request: Types.PostV1ReportsPendingQuotesApprovalsRequest): Promise<Types.PostV1ReportsPendingQuotesApprovalsResponses> => {
  return await _postV1ReportsPendingQuotesApprovals(baseUrl, request)
}
const _postV1ReportsOrderFulfillmentDelivery = async (url: string, request: Types.PostV1ReportsOrderFulfillmentDeliveryRequest): Promise<Types.PostV1ReportsOrderFulfillmentDeliveryResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/order-fulfillment-delivery`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsOrderFulfillmentDelivery: Api['postV1ReportsOrderFulfillmentDelivery'] = async (request: Types.PostV1ReportsOrderFulfillmentDeliveryRequest): Promise<Types.PostV1ReportsOrderFulfillmentDeliveryResponses> => {
  return await _postV1ReportsOrderFulfillmentDelivery(baseUrl, request)
}
const _postV1ReportsSalespersonIncentive = async (url: string, request: Types.PostV1ReportsSalespersonIncentiveRequest): Promise<Types.PostV1ReportsSalespersonIncentiveResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/salesperson-incentive`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsSalespersonIncentive: Api['postV1ReportsSalespersonIncentive'] = async (request: Types.PostV1ReportsSalespersonIncentiveRequest): Promise<Types.PostV1ReportsSalespersonIncentiveResponses> => {
  return await _postV1ReportsSalespersonIncentive(baseUrl, request)
}
const _postV1ReportsSalesChannelAnalysis = async (url: string, request: Types.PostV1ReportsSalesChannelAnalysisRequest): Promise<Types.PostV1ReportsSalesChannelAnalysisResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/sales-channel-analysis`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsSalesChannelAnalysis: Api['postV1ReportsSalesChannelAnalysis'] = async (request: Types.PostV1ReportsSalesChannelAnalysisRequest): Promise<Types.PostV1ReportsSalesChannelAnalysisResponses> => {
  return await _postV1ReportsSalesChannelAnalysis(baseUrl, request)
}
const _postV1ReportsDiscountPromotionAnalysis = async (url: string, request: Types.PostV1ReportsDiscountPromotionAnalysisRequest): Promise<Types.PostV1ReportsDiscountPromotionAnalysisResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/discount-promotion-analysis`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsDiscountPromotionAnalysis: Api['postV1ReportsDiscountPromotionAnalysis'] = async (request: Types.PostV1ReportsDiscountPromotionAnalysisRequest): Promise<Types.PostV1ReportsDiscountPromotionAnalysisResponses> => {
  return await _postV1ReportsDiscountPromotionAnalysis(baseUrl, request)
}
const _postV1ReportsRegionalBranchSales = async (url: string, request: Types.PostV1ReportsRegionalBranchSalesRequest): Promise<Types.PostV1ReportsRegionalBranchSalesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/regional-branch-sales`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsRegionalBranchSales: Api['postV1ReportsRegionalBranchSales'] = async (request: Types.PostV1ReportsRegionalBranchSalesRequest): Promise<Types.PostV1ReportsRegionalBranchSalesResponses> => {
  return await _postV1ReportsRegionalBranchSales(baseUrl, request)
}
const _postV1ReportsSalesBySalespersonPerformance = async (url: string, request: Types.PostV1ReportsSalesBySalespersonPerformanceRequest): Promise<Types.PostV1ReportsSalesBySalespersonPerformanceResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/sales-by-salesperson-performance`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsSalesBySalespersonPerformance: Api['postV1ReportsSalesBySalespersonPerformance'] = async (request: Types.PostV1ReportsSalesBySalespersonPerformanceRequest): Promise<Types.PostV1ReportsSalesBySalespersonPerformanceResponses> => {
  return await _postV1ReportsSalesBySalespersonPerformance(baseUrl, request)
}
const _postV1ReportsReturnCreditReport = async (url: string, request: Types.PostV1ReportsReturnCreditReportRequest): Promise<Types.PostV1ReportsReturnCreditReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/return-credit-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsReturnCreditReport: Api['postV1ReportsReturnCreditReport'] = async (request: Types.PostV1ReportsReturnCreditReportRequest): Promise<Types.PostV1ReportsReturnCreditReportResponses> => {
  return await _postV1ReportsReturnCreditReport(baseUrl, request)
}
const _postV1ReportsCustomerChurnReport = async (url: string, request: Types.PostV1ReportsCustomerChurnReportRequest): Promise<Types.PostV1ReportsCustomerChurnReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/customer-churn-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsCustomerChurnReport: Api['postV1ReportsCustomerChurnReport'] = async (request: Types.PostV1ReportsCustomerChurnReportRequest): Promise<Types.PostV1ReportsCustomerChurnReportResponses> => {
  return await _postV1ReportsCustomerChurnReport(baseUrl, request)
}
const _postV1ReportsSalesByProductReport = async (url: string, request: Types.PostV1ReportsSalesByProductReportRequest): Promise<Types.PostV1ReportsSalesByProductReportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/sales-by-product-report`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsSalesByProductReport: Api['postV1ReportsSalesByProductReport'] = async (request: Types.PostV1ReportsSalesByProductReportRequest): Promise<Types.PostV1ReportsSalesByProductReportResponses> => {
  return await _postV1ReportsSalesByProductReport(baseUrl, request)
}
const _postV1ReportsExport = async (url: string, request: Types.PostV1ReportsExportRequest): Promise<Types.PostV1ReportsExportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/reports/export`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1ReportsExport: Api['postV1ReportsExport'] = async (request: Types.PostV1ReportsExportRequest): Promise<Types.PostV1ReportsExportResponses> => {
  return await _postV1ReportsExport(baseUrl, request)
}
const _postV1SalesTermsConditions = async (url: string, request: Types.PostV1SalesTermsConditionsRequest): Promise<Types.PostV1SalesTermsConditionsResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-terms-conditions/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesTermsConditions: Api['postV1SalesTermsConditions'] = async (request: Types.PostV1SalesTermsConditionsRequest): Promise<Types.PostV1SalesTermsConditionsResponses> => {
  return await _postV1SalesTermsConditions(baseUrl, request)
}
const _getV1SalesTermsConditions = async (url: string, request: Types.GetV1SalesTermsConditionsRequest): Promise<Types.GetV1SalesTermsConditionsResponses> => {
  const queryParameters: (keyof Types.GetV1SalesTermsConditionsRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-terms-conditions/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesTermsConditions: Api['getV1SalesTermsConditions'] = async (request: Types.GetV1SalesTermsConditionsRequest): Promise<Types.GetV1SalesTermsConditionsResponses> => {
  return await _getV1SalesTermsConditions(baseUrl, request)
}
const _getV1SalesTermsConditionsId = async (url: string, request: Types.GetV1SalesTermsConditionsIdRequest): Promise<Types.GetV1SalesTermsConditionsIdResponses> => {
  const queryParameters: (keyof Types.GetV1SalesTermsConditionsIdRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-terms-conditions/${request['id']}?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesTermsConditionsId: Api['getV1SalesTermsConditionsId'] = async (request: Types.GetV1SalesTermsConditionsIdRequest): Promise<Types.GetV1SalesTermsConditionsIdResponses> => {
  return await _getV1SalesTermsConditionsId(baseUrl, request)
}
const _putV1SalesTermsConditionsId = async (url: string, request: Types.PutV1SalesTermsConditionsIdRequest): Promise<Types.PutV1SalesTermsConditionsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-terms-conditions/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1SalesTermsConditionsId: Api['putV1SalesTermsConditionsId'] = async (request: Types.PutV1SalesTermsConditionsIdRequest): Promise<Types.PutV1SalesTermsConditionsIdResponses> => {
  return await _putV1SalesTermsConditionsId(baseUrl, request)
}
const _deleteV1SalesTermsConditionsId = async (url: string, request: Types.DeleteV1SalesTermsConditionsIdRequest): Promise<Types.DeleteV1SalesTermsConditionsIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-terms-conditions/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1SalesTermsConditionsId: Api['deleteV1SalesTermsConditionsId'] = async (request: Types.DeleteV1SalesTermsConditionsIdRequest): Promise<Types.DeleteV1SalesTermsConditionsIdResponses> => {
  return await _deleteV1SalesTermsConditionsId(baseUrl, request)
}
const _patchV1SalesTermsConditionsStatusId = async (url: string, request: Types.PatchV1SalesTermsConditionsStatusIdRequest): Promise<Types.PatchV1SalesTermsConditionsStatusIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-terms-conditions/status/${request['id']}`, {
    method: 'PATCH',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const patchV1SalesTermsConditionsStatusId: Api['patchV1SalesTermsConditionsStatusId'] = async (request: Types.PatchV1SalesTermsConditionsStatusIdRequest): Promise<Types.PatchV1SalesTermsConditionsStatusIdResponses> => {
  return await _patchV1SalesTermsConditionsStatusId(baseUrl, request)
}
const _getV1SalesTermsConditionsGenerateExcel = async (url: string, request: Types.GetV1SalesTermsConditionsGenerateExcelRequest): Promise<Types.GetV1SalesTermsConditionsGenerateExcelResponses> => {
  const queryParameters: (keyof Types.GetV1SalesTermsConditionsGenerateExcelRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['Content-Type'] !== undefined) {
    headers['Content-Type'] = request['Content-Type']
    delete request['Content-Type']
  }

  const response = await fetch(`${url}/v1/sales-terms-conditions/generate-excel?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SalesTermsConditionsGenerateExcel: Api['getV1SalesTermsConditionsGenerateExcel'] = async (request: Types.GetV1SalesTermsConditionsGenerateExcelRequest): Promise<Types.GetV1SalesTermsConditionsGenerateExcelResponses> => {
  return await _getV1SalesTermsConditionsGenerateExcel(baseUrl, request)
}
const _postV1SalesTermsConditionsImport = async (url: string, request: Types.PostV1SalesTermsConditionsImportRequest): Promise<Types.PostV1SalesTermsConditionsImportResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/sales-terms-conditions/import`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SalesTermsConditionsImport: Api['postV1SalesTermsConditionsImport'] = async (request: Types.PostV1SalesTermsConditionsImportRequest): Promise<Types.PostV1SalesTermsConditionsImportResponses> => {
  return await _postV1SalesTermsConditionsImport(baseUrl, request)
}
const _postV1SourceTypes = async (url: string, request: Types.PostV1SourceTypesRequest): Promise<Types.PostV1SourceTypesResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/source-types/`, {
    method: 'POST',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const postV1SourceTypes: Api['postV1SourceTypes'] = async (request: Types.PostV1SourceTypesRequest): Promise<Types.PostV1SourceTypesResponses> => {
  return await _postV1SourceTypes(baseUrl, request)
}
const _getV1SourceTypes = async (url: string, request: Types.GetV1SourceTypesRequest): Promise<Types.GetV1SourceTypesResponses> => {
  const queryParameters: (keyof Types.GetV1SourceTypesRequest)[]  = ['skip', 'limit', 'order', 'filters', 'search', 'select']
  const searchParams = new URLSearchParams()
  queryParameters.forEach((qp) => {
    if (request[qp]) {
      if (Array.isArray(request[qp])) {
        (request[qp] as string[]).forEach((p) => {
          searchParams.append(qp, p)
        })
      } else {
        searchParams.append(qp, request[qp]?.toString() || '')
      }
    }
    delete request[qp]
  })

  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/source-types/?${searchParams.toString()}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SourceTypes: Api['getV1SourceTypes'] = async (request: Types.GetV1SourceTypesRequest): Promise<Types.GetV1SourceTypesResponses> => {
  return await _getV1SourceTypes(baseUrl, request)
}
const _getV1SourceTypesId = async (url: string, request: Types.GetV1SourceTypesIdRequest): Promise<Types.GetV1SourceTypesIdResponses> => {
  const headers = {
    ...defaultHeaders
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/source-types/${request['id']}`, {
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const getV1SourceTypesId: Api['getV1SourceTypesId'] = async (request: Types.GetV1SourceTypesIdRequest): Promise<Types.GetV1SourceTypesIdResponses> => {
  return await _getV1SourceTypesId(baseUrl, request)
}
const _putV1SourceTypesId = async (url: string, request: Types.PutV1SourceTypesIdRequest): Promise<Types.PutV1SourceTypesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/source-types/${request['id']}`, {
    method: 'PUT',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const putV1SourceTypesId: Api['putV1SourceTypesId'] = async (request: Types.PutV1SourceTypesIdRequest): Promise<Types.PutV1SourceTypesIdResponses> => {
  return await _putV1SourceTypesId(baseUrl, request)
}
const _deleteV1SourceTypesId = async (url: string, request: Types.DeleteV1SourceTypesIdRequest): Promise<Types.DeleteV1SourceTypesIdResponses> => {
  const headers = {
    ...defaultHeaders,
    'Content-type': 'application/json; charset=utf-8'
  }
  if (request['x-token'] !== undefined) {
    headers['x-token'] = request['x-token']
    delete request['x-token']
  }
  if (request['x-timezone'] !== undefined) {
    headers['x-timezone'] = request['x-timezone']
    delete request['x-timezone']
  }

  const response = await fetch(`${url}/v1/source-types/${request['id']}`, {
    method: 'DELETE',
    body: JSON.stringify(request),
    headers
  })

  if (!response.ok) {
    throw new Error(await response.text())
  }

  return await response.json()
}

export const deleteV1SourceTypesId: Api['deleteV1SourceTypesId'] = async (request: Types.DeleteV1SourceTypesIdRequest): Promise<Types.DeleteV1SourceTypesIdResponses> => {
  return await _deleteV1SourceTypesId(baseUrl, request)
}
type BuildOptions = {
  headers?: Object
}
export default function build (url: string, options?: BuildOptions) {
  url = sanitizeUrl(url)
  if (options?.headers) {
    defaultHeaders = options.headers
  }
  return {
    getV1ShippingRules: _getV1ShippingRules.bind(url, ...arguments),
    postV1ShippingRules: _postV1ShippingRules.bind(url, ...arguments),
    getV1ShippingRulesId: _getV1ShippingRulesId.bind(url, ...arguments),
    putV1ShippingRulesId: _putV1ShippingRulesId.bind(url, ...arguments),
    deleteV1ShippingRulesId: _deleteV1ShippingRulesId.bind(url, ...arguments),
    postV1ShippingRulesSaveAsDraft: _postV1ShippingRulesSaveAsDraft.bind(url, ...arguments),
    getV1ShippingRulesGenerateExcel: _getV1ShippingRulesGenerateExcel.bind(url, ...arguments),
    postV1ShippingRulesImport: _postV1ShippingRulesImport.bind(url, ...arguments),
    getV1ShippingRulesGeneratePdf: _getV1ShippingRulesGeneratePdf.bind(url, ...arguments),
    getV1DeliverySettings: _getV1DeliverySettings.bind(url, ...arguments),
    patchV1DeliverySettingsId: _patchV1DeliverySettingsId.bind(url, ...arguments),
    getV1CustomerSegment: _getV1CustomerSegment.bind(url, ...arguments),
    postV1CustomerSegment: _postV1CustomerSegment.bind(url, ...arguments),
    postV1CustomerSegmentSaveAsDraft: _postV1CustomerSegmentSaveAsDraft.bind(url, ...arguments),
    getV1CustomerSegmentId: _getV1CustomerSegmentId.bind(url, ...arguments),
    putV1CustomerSegmentId: _putV1CustomerSegmentId.bind(url, ...arguments),
    deleteV1CustomerSegmentId: _deleteV1CustomerSegmentId.bind(url, ...arguments),
    getV1CustomerSegmentGenerateExcel: _getV1CustomerSegmentGenerateExcel.bind(url, ...arguments),
    postV1CustomerSegmentImport: _postV1CustomerSegmentImport.bind(url, ...arguments),
    getV1CustomerSegmentGeneratePdf: _getV1CustomerSegmentGeneratePdf.bind(url, ...arguments),
    getV1FileUpload: _getV1FileUpload.bind(url, ...arguments),
    postV1FileUploadMarkComplete: _postV1FileUploadMarkComplete.bind(url, ...arguments),
    getV1Promotion: _getV1Promotion.bind(url, ...arguments),
    postV1Promotion: _postV1Promotion.bind(url, ...arguments),
    postV1PromotionSaveAsDraft: _postV1PromotionSaveAsDraft.bind(url, ...arguments),
    getV1PromotionId: _getV1PromotionId.bind(url, ...arguments),
    putV1PromotionId: _putV1PromotionId.bind(url, ...arguments),
    deleteV1PromotionId: _deleteV1PromotionId.bind(url, ...arguments),
    postV1PromotionCoupon: _postV1PromotionCoupon.bind(url, ...arguments),
    getV1PromotionCoupon: _getV1PromotionCoupon.bind(url, ...arguments),
    getV1PromotionCouponId: _getV1PromotionCouponId.bind(url, ...arguments),
    deleteV1PromotionCouponId: _deleteV1PromotionCouponId.bind(url, ...arguments),
    putV1PromotionCouponId: _putV1PromotionCouponId.bind(url, ...arguments),
    postV1PromotionReward: _postV1PromotionReward.bind(url, ...arguments),
    getV1PromotionReward: _getV1PromotionReward.bind(url, ...arguments),
    getV1PromotionRewardId: _getV1PromotionRewardId.bind(url, ...arguments),
    deleteV1PromotionRewardId: _deleteV1PromotionRewardId.bind(url, ...arguments),
    putV1PromotionRewardId: _putV1PromotionRewardId.bind(url, ...arguments),
    getV1PromotionGenerateExcel: _getV1PromotionGenerateExcel.bind(url, ...arguments),
    postV1PromotionImport: _postV1PromotionImport.bind(url, ...arguments),
    getV1PromotionGeneratePdf: _getV1PromotionGeneratePdf.bind(url, ...arguments),
    getV1Lead: _getV1Lead.bind(url, ...arguments),
    postV1Lead: _postV1Lead.bind(url, ...arguments),
    postV1LeadCheck: _postV1LeadCheck.bind(url, ...arguments),
    postV1LeadSaveAsDraft: _postV1LeadSaveAsDraft.bind(url, ...arguments),
    getV1LeadId: _getV1LeadId.bind(url, ...arguments),
    putV1LeadId: _putV1LeadId.bind(url, ...arguments),
    deleteV1LeadId: _deleteV1LeadId.bind(url, ...arguments),
    patchV1LeadLeadStatusId: _patchV1LeadLeadStatusId.bind(url, ...arguments),
    patchV1LeadLeadToOpportunityId: _patchV1LeadLeadToOpportunityId.bind(url, ...arguments),
    postV1LeadFollowup: _postV1LeadFollowup.bind(url, ...arguments),
    getV1LeadFollowup: _getV1LeadFollowup.bind(url, ...arguments),
    getV1LeadFollowupId: _getV1LeadFollowupId.bind(url, ...arguments),
    deleteV1LeadFollowupId: _deleteV1LeadFollowupId.bind(url, ...arguments),
    putV1LeadFollowupId: _putV1LeadFollowupId.bind(url, ...arguments),
    postV1LeadCommunicationLog: _postV1LeadCommunicationLog.bind(url, ...arguments),
    getV1LeadCommunicationLog: _getV1LeadCommunicationLog.bind(url, ...arguments),
    getV1LeadCommunicationLogId: _getV1LeadCommunicationLogId.bind(url, ...arguments),
    deleteV1LeadCommunicationLogId: _deleteV1LeadCommunicationLogId.bind(url, ...arguments),
    putV1LeadCommunicationLogId: _putV1LeadCommunicationLogId.bind(url, ...arguments),
    postV1LeadAddress: _postV1LeadAddress.bind(url, ...arguments),
    getV1LeadAddress: _getV1LeadAddress.bind(url, ...arguments),
    getV1LeadAddressId: _getV1LeadAddressId.bind(url, ...arguments),
    deleteV1LeadAddressId: _deleteV1LeadAddressId.bind(url, ...arguments),
    putV1LeadAddressId: _putV1LeadAddressId.bind(url, ...arguments),
    postV1LeadContact: _postV1LeadContact.bind(url, ...arguments),
    getV1LeadContact: _getV1LeadContact.bind(url, ...arguments),
    getV1LeadContactId: _getV1LeadContactId.bind(url, ...arguments),
    deleteV1LeadContactId: _deleteV1LeadContactId.bind(url, ...arguments),
    putV1LeadContactId: _putV1LeadContactId.bind(url, ...arguments),
    getV1LeadIdDownload: _getV1LeadIdDownload.bind(url, ...arguments),
    getV1LeadIdSendEmail: _getV1LeadIdSendEmail.bind(url, ...arguments),
    getV1LeadGenerateExcel: _getV1LeadGenerateExcel.bind(url, ...arguments),
    postV1LeadImport: _postV1LeadImport.bind(url, ...arguments),
    getV1LeadGeneratePdf: _getV1LeadGeneratePdf.bind(url, ...arguments),
    postV1OpportunityPromotionCheck: _postV1OpportunityPromotionCheck.bind(url, ...arguments),
    postV1OpportunityPromotionApply: _postV1OpportunityPromotionApply.bind(url, ...arguments),
    postV1OpportunityPromotionItemApply: _postV1OpportunityPromotionItemApply.bind(url, ...arguments),
    deleteV1OpportunityPromotionId: _deleteV1OpportunityPromotionId.bind(url, ...arguments),
    getV1Opportunity: _getV1Opportunity.bind(url, ...arguments),
    postV1Opportunity: _postV1Opportunity.bind(url, ...arguments),
    postV1OpportunitySaveAsDraft: _postV1OpportunitySaveAsDraft.bind(url, ...arguments),
    getV1OpportunityId: _getV1OpportunityId.bind(url, ...arguments),
    putV1OpportunityId: _putV1OpportunityId.bind(url, ...arguments),
    deleteV1OpportunityId: _deleteV1OpportunityId.bind(url, ...arguments),
    patchV1OpportunityStageId: _patchV1OpportunityStageId.bind(url, ...arguments),
    postV1OpportunityFollowup: _postV1OpportunityFollowup.bind(url, ...arguments),
    getV1OpportunityFollowup: _getV1OpportunityFollowup.bind(url, ...arguments),
    getV1OpportunityFollowupId: _getV1OpportunityFollowupId.bind(url, ...arguments),
    deleteV1OpportunityFollowupId: _deleteV1OpportunityFollowupId.bind(url, ...arguments),
    putV1OpportunityFollowupId: _putV1OpportunityFollowupId.bind(url, ...arguments),
    postV1OpportunityCommunicationLog: _postV1OpportunityCommunicationLog.bind(url, ...arguments),
    getV1OpportunityCommunicationLog: _getV1OpportunityCommunicationLog.bind(url, ...arguments),
    getV1OpportunityCommunicationLogId: _getV1OpportunityCommunicationLogId.bind(url, ...arguments),
    deleteV1OpportunityCommunicationLogId: _deleteV1OpportunityCommunicationLogId.bind(url, ...arguments),
    putV1OpportunityCommunicationLogId: _putV1OpportunityCommunicationLogId.bind(url, ...arguments),
    postV1OpportunityAddress: _postV1OpportunityAddress.bind(url, ...arguments),
    getV1OpportunityAddress: _getV1OpportunityAddress.bind(url, ...arguments),
    getV1OpportunityAddressId: _getV1OpportunityAddressId.bind(url, ...arguments),
    deleteV1OpportunityAddressId: _deleteV1OpportunityAddressId.bind(url, ...arguments),
    putV1OpportunityAddressId: _putV1OpportunityAddressId.bind(url, ...arguments),
    postV1OpportunityContact: _postV1OpportunityContact.bind(url, ...arguments),
    getV1OpportunityContact: _getV1OpportunityContact.bind(url, ...arguments),
    getV1OpportunityContactId: _getV1OpportunityContactId.bind(url, ...arguments),
    deleteV1OpportunityContactId: _deleteV1OpportunityContactId.bind(url, ...arguments),
    putV1OpportunityContactId: _putV1OpportunityContactId.bind(url, ...arguments),
    postV1OpportunityItem: _postV1OpportunityItem.bind(url, ...arguments),
    getV1OpportunityItem: _getV1OpportunityItem.bind(url, ...arguments),
    getV1OpportunityItemId: _getV1OpportunityItemId.bind(url, ...arguments),
    deleteV1OpportunityItemId: _deleteV1OpportunityItemId.bind(url, ...arguments),
    putV1OpportunityItemId: _putV1OpportunityItemId.bind(url, ...arguments),
    getV1OpportunitySalesPipeline: _getV1OpportunitySalesPipeline.bind(url, ...arguments),
    getV1OpportunityIdPromotions: _getV1OpportunityIdPromotions.bind(url, ...arguments),
    getV1OpportunityGenerateExcel: _getV1OpportunityGenerateExcel.bind(url, ...arguments),
    postV1OpportunityImport: _postV1OpportunityImport.bind(url, ...arguments),
    getV1OpportunityGeneratePdf: _getV1OpportunityGeneratePdf.bind(url, ...arguments),
    postV1Quotation: _postV1Quotation.bind(url, ...arguments),
    getV1Quotation: _getV1Quotation.bind(url, ...arguments),
    getV1QuotationId: _getV1QuotationId.bind(url, ...arguments),
    putV1QuotationId: _putV1QuotationId.bind(url, ...arguments),
    deleteV1QuotationId: _deleteV1QuotationId.bind(url, ...arguments),
    postV1QuotationSaveAsDraft: _postV1QuotationSaveAsDraft.bind(url, ...arguments),
    patchV1QuotationStatusId: _patchV1QuotationStatusId.bind(url, ...arguments),
    postV1QuotationPromotionCheck: _postV1QuotationPromotionCheck.bind(url, ...arguments),
    postV1QuotationPromotionApply: _postV1QuotationPromotionApply.bind(url, ...arguments),
    postV1QuotationPromotionCouponApply: _postV1QuotationPromotionCouponApply.bind(url, ...arguments),
    postV1QuotationPromotionItemApply: _postV1QuotationPromotionItemApply.bind(url, ...arguments),
    deleteV1QuotationPromotionId: _deleteV1QuotationPromotionId.bind(url, ...arguments),
    postV1QuotationItem: _postV1QuotationItem.bind(url, ...arguments),
    getV1QuotationItem: _getV1QuotationItem.bind(url, ...arguments),
    getV1QuotationItemId: _getV1QuotationItemId.bind(url, ...arguments),
    deleteV1QuotationItemId: _deleteV1QuotationItemId.bind(url, ...arguments),
    putV1QuotationItemId: _putV1QuotationItemId.bind(url, ...arguments),
    getV1QuotationIdPromotions: _getV1QuotationIdPromotions.bind(url, ...arguments),
    getV1QuotationIdDownload: _getV1QuotationIdDownload.bind(url, ...arguments),
    getV1QuotationIdSendEmail: _getV1QuotationIdSendEmail.bind(url, ...arguments),
    getV1QuotationGenerateExcel: _getV1QuotationGenerateExcel.bind(url, ...arguments),
    postV1QuotationImport: _postV1QuotationImport.bind(url, ...arguments),
    getV1QuotationOpportunityId: _getV1QuotationOpportunityId.bind(url, ...arguments),
    getV1QuotationFetchItemsPartyId: _getV1QuotationFetchItemsPartyId.bind(url, ...arguments),
    getV1QuotationGeneratePdf: _getV1QuotationGeneratePdf.bind(url, ...arguments),
    postV1SalesOrders: _postV1SalesOrders.bind(url, ...arguments),
    getV1SalesOrders: _getV1SalesOrders.bind(url, ...arguments),
    postV1SalesOrdersSaveDraft: _postV1SalesOrdersSaveDraft.bind(url, ...arguments),
    getV1SalesOrdersId: _getV1SalesOrdersId.bind(url, ...arguments),
    putV1SalesOrdersId: _putV1SalesOrdersId.bind(url, ...arguments),
    deleteV1SalesOrdersId: _deleteV1SalesOrdersId.bind(url, ...arguments),
    patchV1SalesOrdersStatusId: _patchV1SalesOrdersStatusId.bind(url, ...arguments),
    postV1SalesOrdersAddApprover: _postV1SalesOrdersAddApprover.bind(url, ...arguments),
    putV1SalesOrdersApprovalStatusId: _putV1SalesOrdersApprovalStatusId.bind(url, ...arguments),
    postV1SalesOrdersItems: _postV1SalesOrdersItems.bind(url, ...arguments),
    getV1SalesOrdersItemsId: _getV1SalesOrdersItemsId.bind(url, ...arguments),
    putV1SalesOrdersItemsId: _putV1SalesOrdersItemsId.bind(url, ...arguments),
    deleteV1SalesOrdersItemsId: _deleteV1SalesOrdersItemsId.bind(url, ...arguments),
    postV1SalesOrdersPromotionCheck: _postV1SalesOrdersPromotionCheck.bind(url, ...arguments),
    postV1SalesOrdersPromotionApply: _postV1SalesOrdersPromotionApply.bind(url, ...arguments),
    postV1SalesOrdersPromotionItemApply: _postV1SalesOrdersPromotionItemApply.bind(url, ...arguments),
    deleteV1SalesOrdersPromotionId: _deleteV1SalesOrdersPromotionId.bind(url, ...arguments),
    getV1SalesOrdersIdCreateInvoice: _getV1SalesOrdersIdCreateInvoice.bind(url, ...arguments),
    getV1SalesOrdersIdPromotions: _getV1SalesOrdersIdPromotions.bind(url, ...arguments),
    getV1SalesOrdersIdDownload: _getV1SalesOrdersIdDownload.bind(url, ...arguments),
    getV1SalesOrdersIdGeneratePickingList: _getV1SalesOrdersIdGeneratePickingList.bind(url, ...arguments),
    getV1SalesOrdersIdSendEmail: _getV1SalesOrdersIdSendEmail.bind(url, ...arguments),
    getV1SalesOrdersTypeId: _getV1SalesOrdersTypeId.bind(url, ...arguments),
    getV1SalesOrdersGenerateExcel: _getV1SalesOrdersGenerateExcel.bind(url, ...arguments),
    postV1SalesOrdersImport: _postV1SalesOrdersImport.bind(url, ...arguments),
    getV1SalesOrdersInvoiceSchedulesIdProcess: _getV1SalesOrdersInvoiceSchedulesIdProcess.bind(url, ...arguments),
    getV1SalesOrdersInvoiceSchedulesIdGetJob: _getV1SalesOrdersInvoiceSchedulesIdGetJob.bind(url, ...arguments),
    postV1SalesOrdersInvoiceSchedulesScheduleIdProcess: _postV1SalesOrdersInvoiceSchedulesScheduleIdProcess.bind(url, ...arguments),
    getV1SalesOrdersInvoiceJobsJobId: _getV1SalesOrdersInvoiceJobsJobId.bind(url, ...arguments),
    getV1SalesOrdersGeneratePdf: _getV1SalesOrdersGeneratePdf.bind(url, ...arguments),
    postV1DeliveryOrders: _postV1DeliveryOrders.bind(url, ...arguments),
    getV1DeliveryOrders: _getV1DeliveryOrders.bind(url, ...arguments),
    postV1DeliveryOrdersSaveDraft: _postV1DeliveryOrdersSaveDraft.bind(url, ...arguments),
    getV1DeliveryOrdersId: _getV1DeliveryOrdersId.bind(url, ...arguments),
    deleteV1DeliveryOrdersId: _deleteV1DeliveryOrdersId.bind(url, ...arguments),
    putV1DeliveryOrdersId: _putV1DeliveryOrdersId.bind(url, ...arguments),
    patchV1DeliveryOrdersStatusId: _patchV1DeliveryOrdersStatusId.bind(url, ...arguments),
    getV1DeliveryOrdersItemsId: _getV1DeliveryOrdersItemsId.bind(url, ...arguments),
    putV1DeliveryOrdersItemsId: _putV1DeliveryOrdersItemsId.bind(url, ...arguments),
    deleteV1DeliveryOrdersItemsId: _deleteV1DeliveryOrdersItemsId.bind(url, ...arguments),
    postV1DeliveryOrdersPackages: _postV1DeliveryOrdersPackages.bind(url, ...arguments),
    getV1DeliveryOrdersPackagesId: _getV1DeliveryOrdersPackagesId.bind(url, ...arguments),
    putV1DeliveryOrdersPackagesId: _putV1DeliveryOrdersPackagesId.bind(url, ...arguments),
    deleteV1DeliveryOrdersPackagesId: _deleteV1DeliveryOrdersPackagesId.bind(url, ...arguments),
    getV1DeliveryOrdersIdPackages: _getV1DeliveryOrdersIdPackages.bind(url, ...arguments),
    postV1DeliveryOrdersDeliveryIdItemsItemIdPackages: _postV1DeliveryOrdersDeliveryIdItemsItemIdPackages.bind(url, ...arguments),
    getV1DeliveryOrdersDeliveryIdItemsItemIdPackages: _getV1DeliveryOrdersDeliveryIdItemsItemIdPackages.bind(url, ...arguments),
    deleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesId: _deleteV1DeliveryOrdersDeliveryIdItemsItemIdPackagesId.bind(url, ...arguments),
    postV1DeliveryOrdersDeliveryIdItemsItemIdTracking: _postV1DeliveryOrdersDeliveryIdItemsItemIdTracking.bind(url, ...arguments),
    postV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustment: _postV1DeliveryOrdersDeliveryIdItemsItemIdInventoryAdjustment.bind(url, ...arguments),
    getV1DeliveryOrdersIdCreateInvoice: _getV1DeliveryOrdersIdCreateInvoice.bind(url, ...arguments),
    getV1DeliveryOrdersIdSendEmail: _getV1DeliveryOrdersIdSendEmail.bind(url, ...arguments),
    getV1DeliveryOrdersIdDownload: _getV1DeliveryOrdersIdDownload.bind(url, ...arguments),
    getV1DeliveryOrdersGenerateExcel: _getV1DeliveryOrdersGenerateExcel.bind(url, ...arguments),
    getV1DeliveryOrdersSalesOrderId: _getV1DeliveryOrdersSalesOrderId.bind(url, ...arguments),
    deleteV1DeliveryOrdersDeliveryIdPackageItemsId: _deleteV1DeliveryOrdersDeliveryIdPackageItemsId.bind(url, ...arguments),
    getV1DeliveryOrdersGeneratePdf: _getV1DeliveryOrdersGeneratePdf.bind(url, ...arguments),
    getV1CustomerReturns: _getV1CustomerReturns.bind(url, ...arguments),
    postV1CustomerReturns: _postV1CustomerReturns.bind(url, ...arguments),
    postV1CustomerReturnsSaveAsDraft: _postV1CustomerReturnsSaveAsDraft.bind(url, ...arguments),
    getV1CustomerReturnsId: _getV1CustomerReturnsId.bind(url, ...arguments),
    putV1CustomerReturnsId: _putV1CustomerReturnsId.bind(url, ...arguments),
    deleteV1CustomerReturnsId: _deleteV1CustomerReturnsId.bind(url, ...arguments),
    getV1CustomerReturnsCreditNoteRmaId: _getV1CustomerReturnsCreditNoteRmaId.bind(url, ...arguments),
    patchV1CustomerReturnsStatusId: _patchV1CustomerReturnsStatusId.bind(url, ...arguments),
    postV1CustomerReturnsItems: _postV1CustomerReturnsItems.bind(url, ...arguments),
    putV1CustomerReturnsItemsId: _putV1CustomerReturnsItemsId.bind(url, ...arguments),
    deleteV1CustomerReturnsItemsId: _deleteV1CustomerReturnsItemsId.bind(url, ...arguments),
    postV1CustomerReturnsAddApprover: _postV1CustomerReturnsAddApprover.bind(url, ...arguments),
    putV1CustomerReturnsApprovalStatusId: _putV1CustomerReturnsApprovalStatusId.bind(url, ...arguments),
    postV1CustomerReturnsRmaIdGrn: _postV1CustomerReturnsRmaIdGrn.bind(url, ...arguments),
    getV1CustomerReturnsRmaIdGrn: _getV1CustomerReturnsRmaIdGrn.bind(url, ...arguments),
    putV1CustomerReturnsRmaIdGrnId: _putV1CustomerReturnsRmaIdGrnId.bind(url, ...arguments),
    deleteV1CustomerReturnsRmaIdGrnId: _deleteV1CustomerReturnsRmaIdGrnId.bind(url, ...arguments),
    getV1CustomerReturnsRmaIdGrnId: _getV1CustomerReturnsRmaIdGrnId.bind(url, ...arguments),
    getV1CustomerReturnsRmaIdGrnGrnIdItemId: _getV1CustomerReturnsRmaIdGrnGrnIdItemId.bind(url, ...arguments),
    putV1CustomerReturnsRmaIdGrnGrnIdItemId: _putV1CustomerReturnsRmaIdGrnGrnIdItemId.bind(url, ...arguments),
    deleteV1CustomerReturnsRmaIdGrnGrnIdItemId: _deleteV1CustomerReturnsRmaIdGrnGrnIdItemId.bind(url, ...arguments),
    postV1CustomerReturnsRmaIdGrnGrnIdItemsItemIdTracking: _postV1CustomerReturnsRmaIdGrnGrnIdItemsItemIdTracking.bind(url, ...arguments),
    postV1CustomerReturnsRmaIdGrnGrnIdInventoryAdjustment: _postV1CustomerReturnsRmaIdGrnGrnIdInventoryAdjustment.bind(url, ...arguments),
    postV1CustomerReturnsRmaIdGrnGrnIdReturnSalesOrder: _postV1CustomerReturnsRmaIdGrnGrnIdReturnSalesOrder.bind(url, ...arguments),
    getV1CustomerReturnsGenerateExcel: _getV1CustomerReturnsGenerateExcel.bind(url, ...arguments),
    postV1CustomerReturnsImport: _postV1CustomerReturnsImport.bind(url, ...arguments),
    getV1CustomerReturnsGeneratePdf: _getV1CustomerReturnsGeneratePdf.bind(url, ...arguments),
    postV1ReportsSalesOrderSummary: _postV1ReportsSalesOrderSummary.bind(url, ...arguments),
    postV1ReportsSalesOrderDetail: _postV1ReportsSalesOrderDetail.bind(url, ...arguments),
    postV1ReportsPendingQuotesApprovals: _postV1ReportsPendingQuotesApprovals.bind(url, ...arguments),
    postV1ReportsOrderFulfillmentDelivery: _postV1ReportsOrderFulfillmentDelivery.bind(url, ...arguments),
    postV1ReportsSalespersonIncentive: _postV1ReportsSalespersonIncentive.bind(url, ...arguments),
    postV1ReportsSalesChannelAnalysis: _postV1ReportsSalesChannelAnalysis.bind(url, ...arguments),
    postV1ReportsDiscountPromotionAnalysis: _postV1ReportsDiscountPromotionAnalysis.bind(url, ...arguments),
    postV1ReportsRegionalBranchSales: _postV1ReportsRegionalBranchSales.bind(url, ...arguments),
    postV1ReportsSalesBySalespersonPerformance: _postV1ReportsSalesBySalespersonPerformance.bind(url, ...arguments),
    postV1ReportsReturnCreditReport: _postV1ReportsReturnCreditReport.bind(url, ...arguments),
    postV1ReportsCustomerChurnReport: _postV1ReportsCustomerChurnReport.bind(url, ...arguments),
    postV1ReportsSalesByProductReport: _postV1ReportsSalesByProductReport.bind(url, ...arguments),
    postV1ReportsExport: _postV1ReportsExport.bind(url, ...arguments),
    postV1SalesTermsConditions: _postV1SalesTermsConditions.bind(url, ...arguments),
    getV1SalesTermsConditions: _getV1SalesTermsConditions.bind(url, ...arguments),
    getV1SalesTermsConditionsId: _getV1SalesTermsConditionsId.bind(url, ...arguments),
    putV1SalesTermsConditionsId: _putV1SalesTermsConditionsId.bind(url, ...arguments),
    deleteV1SalesTermsConditionsId: _deleteV1SalesTermsConditionsId.bind(url, ...arguments),
    patchV1SalesTermsConditionsStatusId: _patchV1SalesTermsConditionsStatusId.bind(url, ...arguments),
    getV1SalesTermsConditionsGenerateExcel: _getV1SalesTermsConditionsGenerateExcel.bind(url, ...arguments),
    postV1SalesTermsConditionsImport: _postV1SalesTermsConditionsImport.bind(url, ...arguments),
    postV1SourceTypes: _postV1SourceTypes.bind(url, ...arguments),
    getV1SourceTypes: _getV1SourceTypes.bind(url, ...arguments),
    getV1SourceTypesId: _getV1SourceTypesId.bind(url, ...arguments),
    putV1SourceTypesId: _putV1SourceTypesId.bind(url, ...arguments),
    deleteV1SourceTypesId: _deleteV1SourceTypesId.bind(url, ...arguments)
  }
}